/* Chili Drop: the Chili Chews catch game.
   Hold the bag, catch the chews, dodge the bad stuff. Catch the goal number to unlock a free mystery 2-pack,
   then keep going for the high score: it speeds up until three bland gummies end the run.
   Config comes from #ccg-config (section settings). No dependencies. */
(() => {
  'use strict';
  const root = document.querySelector('[data-ccg]');
  const cfgEl = document.getElementById('ccg-config');
  if (!root || !cfgEl) return;
  const CFG = JSON.parse(cfgEl.textContent);
  const CODE = (() => { try { return atob(CFG.code || ''); } catch (_) { return ''; } })();
  const GOAL = CFG.target || 15;
  const LIVES = CFG.strikes || 3;
  // Halloween edition: spooky art, a +5 bullseye bonus and a weekly prize board ('hw' on the API)
  const HW = CFG.skin === 'halloween';
  const BOARD = CFG.board || '';
  const PRIZE = CFG.prize || '';
  // "goal": false = high score only: every run counts for the board, no catch-the-goal step and no free 2-pack
  const NO_GOAL = CFG.goal === false;
  let leaderScore = 0; // this week's top score (weekly board), the number to beat in the HUD

  const $ = (s, r = root) => r.querySelector(s);
  const $$ = (s, r = root) => [...r.querySelectorAll(s)];
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const rand = (a, b) => a + Math.random() * (b - a);
  const pick = (arr) => arr[(Math.random() * arr.length) | 0];
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const vibrate = (p) => { try { navigator.vibrate?.(p); } catch (_) {} };

  /* Per-browser memory: runs lost before the goal (drives the bag upgrades), best score, claimed gift */
  const KEY = 'ccg_v1';
  const saved = (() => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (_) { return {}; } })();
  const persist = () => { try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (_) {} };
  saved.losses = saved.losses || 0;
  saved.plays = saved.plays || 0;
  saved.bestScore = saved.bestScore || 0;

  const track = (name, data = {}) => {
    data = { game: 'chili_drop', ...data };
    try { window.Shopify?.analytics?.publish?.(name, data); } catch (_) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: name, ...data }); } catch (_) {}
  };

  /* Sound: tiny WebAudio synth, created on the first tap */
  const Sound = {
    ctx: null,
    muted: !!saved.muted,
    init() {
      if (this.ctx) { if (this.ctx.state === 'suspended') this.ctx.resume(); return; }
      const AC = window.AudioContext || window.webkitAudioContext;
      if (AC) try { this.ctx = new AC(); } catch (_) {}
    },
    tone(freq, dur, { type = 'sine', vol = 0.12, to = 0, delay = 0 } = {}) {
      if (this.muted || !this.ctx) return;
      const t0 = this.ctx.currentTime + delay;
      const o = this.ctx.createOscillator();
      const g = this.ctx.createGain();
      o.type = type;
      o.frequency.setValueAtTime(freq, t0);
      if (to) o.frequency.exponentialRampToValueAtTime(to, t0 + dur);
      g.gain.setValueAtTime(0.0001, t0);
      g.gain.exponentialRampToValueAtTime(vol, t0 + 0.012);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
      o.connect(g).connect(this.ctx.destination);
      o.start(t0);
      o.stop(t0 + dur + 0.03);
    },
    noise(dur, { vol = 0.1, freq = 1500, q = 1, delay = 0 } = {}) {
      if (this.muted || !this.ctx) return;
      const t0 = this.ctx.currentTime + delay;
      const len = Math.max(1, Math.floor(this.ctx.sampleRate * dur));
      const buf = this.ctx.createBuffer(1, len, this.ctx.sampleRate);
      const d = buf.getChannelData(0);
      for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / len);
      const src = this.ctx.createBufferSource();
      const f = this.ctx.createBiquadFilter();
      const g = this.ctx.createGain();
      src.buffer = buf;
      f.type = 'bandpass';
      f.frequency.value = freq;
      f.Q.value = q;
      g.gain.value = vol;
      src.connect(f).connect(g).connect(this.ctx.destination);
      src.start(t0);
    },
    chew(streak) { const f = 520 * Math.pow(1.045, Math.min(streak, 16)); this.tone(f, 0.09, { type: 'triangle', vol: 0.14, to: f * 1.5 }); },
    bland() { this.tone(170, 0.28, { type: 'square', vol: 0.06, to: 70 }); },
    crunch() { this.noise(0.09, { vol: 0.3, freq: 2200, q: 0.8 }); this.noise(0.07, { vol: 0.25, freq: 1400, delay: 0.08 }); },
    freeze() { this.tone(2200, 0.45, { type: 'sine', vol: 0.06, to: 500 }); this.noise(0.3, { vol: 0.12, freq: 6000, q: 2 }); },
    refill() { [500, 750, 1000].forEach((f, i) => this.tone(f, 0.1, { type: 'triangle', vol: 0.12, delay: i * 0.07 })); },
    pepper() { [0, 0.06, 0.12].forEach((d, i) => this.tone(380 + i * 190, 0.16, { type: 'sawtooth', vol: 0.045, to: 900 + i * 300, delay: d })); },
    toast() { this.tone(320, 0.14, { type: 'sawtooth', vol: 0.045, to: 110 }); },
    speedup() { this.tone(300, 0.3, { type: 'sawtooth', vol: 0.05, to: 1200 }); },
    tick(hi) { this.tone(hi ? 1046 : 784, 0.08, { type: 'square', vol: 0.045 }); },
    win() { [523, 659, 784, 1047, 1319].forEach((f, i) => this.tone(f, 0.24, { type: 'triangle', vol: 0.13, delay: i * 0.09 })); },
    lose() { [392, 330, 262].forEach((f, i) => this.tone(f, 0.26, { type: 'triangle', vol: 0.1, delay: i * 0.15 })); },
  };

  /* Art. Good stuff is real product photography; bad stuff is cartoon. */
  const loadImg = (src) => new Promise((res) => {
    if (!src) return res(null);
    const i = new Image();
    i.decoding = 'async';
    i.onload = () => res(i);
    i.onerror = () => res(null);
    i.src = src;
  });
  const shade = (hex, k = 0.82) => {
    const n = parseInt(hex.slice(1), 16);
    const c = (v) => clamp(Math.round(v * k), 0, 255).toString(16).padStart(2, '0');
    return `#${c(n >> 16)}${c((n >> 8) & 255)}${c(n & 255)}`;
  };
  const INK = '#140b12';
  const canvas128 = () => {
    const c = document.createElement('canvas');
    c.width = c.height = 128;
    const x = c.getContext('2d');
    x.lineJoin = 'round';
    x.lineCap = 'round';
    return [c, x];
  };
  // Sticker treatment for a cartoon sprite: soft drop shadow, thick white outline, then the drawing
  const sticker = (x, outline, paint) => {
    x.save(); x.translate(0, 6); outline(); x.lineWidth = 14; x.strokeStyle = 'rgba(20,11,18,.3)'; x.stroke(); x.restore();
    outline(); x.lineWidth = 14; x.strokeStyle = '#fffefa'; x.stroke(); x.fillStyle = '#fffefa'; x.fill();
    paint();
  };
  // Bland: a plain sugar gummy with zero heat and an unimpressed face
  const makeBland = (fill, seed) => {
    const [c, x] = canvas128();
    const blob = () => {
      x.beginPath();
      x.moveTo(64, 15);
      x.bezierCurveTo(98, 15, 115, 37, 113, 64);
      x.bezierCurveTo(111, 96, 92, 114, 62, 113);
      x.bezierCurveTo(32, 112, 15, 93, 16, 63);
      x.bezierCurveTo(17, 35, 35, 15, 64, 15);
      x.closePath();
    };
    sticker(x, blob, () => {
      blob();
      const g = x.createRadialGradient(46, 40, 4, 64, 64, 62);
      g.addColorStop(0, '#ffffff');
      g.addColorStop(0.28, fill);
      g.addColorStop(1, shade(fill));
      x.fillStyle = g; x.fill();
      x.lineWidth = 3.5; x.strokeStyle = INK; x.stroke();
      x.save(); blob(); x.clip();
      let s = seed;
      const r = () => ((s = (s * 9301 + 49297) % 233280) / 233280);
      for (let i = 0; i < 80; i++) { x.fillStyle = `rgba(255,255,255,${0.35 + r() * 0.5})`; x.fillRect(18 + r() * 92, 18 + r() * 92, 2.4, 2.4); }
      x.restore();
      x.strokeStyle = INK;
      x.lineWidth = 5.5; x.beginPath(); x.moveTo(41, 62); x.lineTo(54, 62); x.moveTo(74, 62); x.lineTo(87, 62); x.stroke();
      x.lineWidth = 3.2; x.beginPath(); x.moveTo(39, 54); x.quadraticCurveTo(47, 50, 56, 54); x.moveTo(72, 54); x.quadraticCurveTo(81, 50, 89, 54); x.stroke();
      x.lineWidth = 5; x.beginPath(); x.moveTo(51, 86); x.quadraticCurveTo(64, 83, 77, 87); x.stroke();
    });
    return c;
  };
  // Celery: the health snack that shrinks your bag. Smug.
  const makeCelery = () => {
    const [c, x] = canvas128();
    const leaves = [[50, 26, 15], [66, 18, 16], [82, 27, 14], [60, 34, 12], [76, 36, 12]];
    const outline = () => {
      x.beginPath();
      x.roundRect ? x.roundRect(46, 30, 36, 88, 16) : x.rect(46, 30, 36, 88);
      leaves.forEach(([lx, ly, lr]) => { x.moveTo(lx + lr, ly); x.arc(lx, ly, lr, 0, Math.PI * 2); });
    };
    sticker(x, outline, () => {
      x.beginPath();
      x.roundRect ? x.roundRect(46, 30, 36, 88, 16) : x.rect(46, 30, 36, 88);
      const g = x.createLinearGradient(46, 0, 82, 0);
      g.addColorStop(0, '#c9e88a'); g.addColorStop(0.5, '#b4dc6c'); g.addColorStop(1, '#93c24f');
      x.fillStyle = g; x.fill();
      x.lineWidth = 3.5; x.strokeStyle = INK; x.stroke();
      x.strokeStyle = 'rgba(70,120,30,.55)'; x.lineWidth = 2.5;
      [55, 64, 73].forEach((lx) => { x.beginPath(); x.moveTo(lx, 40); x.lineTo(lx, 110); x.stroke(); });
      leaves.forEach(([lx, ly, lr], i) => {
        x.beginPath(); x.arc(lx, ly, lr, 0, Math.PI * 2);
        x.fillStyle = i % 2 ? '#5f9e2f' : '#73b33a'; x.fill();
        x.lineWidth = 3.2; x.strokeStyle = INK; x.stroke();
      });
      x.strokeStyle = INK;
      x.lineWidth = 3; x.beginPath(); x.moveTo(52, 64); x.lineTo(60, 61); x.moveTo(68, 61); x.lineTo(76, 64); x.stroke();
      x.fillStyle = INK; x.beginPath(); x.arc(57, 70, 3.2, 0, 7); x.arc(71, 70, 3.2, 0, 7); x.fill();
      x.lineWidth = 3.2; x.beginPath(); x.moveTo(57, 84); x.quadraticCurveTo(66, 90, 73, 82); x.stroke();
    });
    return c;
  };
  // Ice cube: brain freeze, your hand locks up for a second
  const makeIce = () => {
    const [c, x] = canvas128();
    const cube = () => { x.beginPath(); x.roundRect ? x.roundRect(24, 24, 80, 80, 18) : x.rect(24, 24, 80, 80); };
    x.translate(64, 64); x.rotate(-0.12); x.translate(-64, -64);
    sticker(x, cube, () => {
      cube();
      const g = x.createLinearGradient(24, 24, 104, 104);
      g.addColorStop(0, '#effbff'); g.addColorStop(0.5, '#bfe9ff'); g.addColorStop(1, '#8fd3f5');
      x.fillStyle = g; x.fill();
      x.lineWidth = 3.5; x.strokeStyle = INK; x.stroke();
      x.fillStyle = 'rgba(255,255,255,.85)';
      x.beginPath(); x.roundRect ? x.roundRect(33, 32, 26, 10, 5) : x.rect(33, 32, 26, 10); x.fill();
      x.strokeStyle = INK; x.lineWidth = 3.2;
      x.beginPath(); x.moveTo(44, 58); x.lineTo(54, 63); x.lineTo(44, 68); x.moveTo(84, 58); x.lineTo(74, 63); x.lineTo(84, 68); x.stroke();
      x.lineWidth = 3; x.beginPath(); x.moveTo(46, 84);
      for (let i = 1; i <= 6; i++) x.lineTo(46 + i * 6, i % 2 ? 79 : 85);
      x.stroke();
    });
    return c;
  };
  // Halloween hazards. Ghost: a sheet ghost that costs a life (the bland gummy's job)
  const makeGhost = (fill, seed) => {
    const [c, x] = canvas128();
    const lean = ((seed % 7) - 3) * 0.02;
    x.translate(64, 64); x.rotate(lean); x.translate(-64, -64);
    const sheet = () => {
      x.beginPath();
      x.moveTo(26, 110);
      x.lineTo(26, 58);
      x.bezierCurveTo(26, 30, 43, 13, 64, 13);
      x.bezierCurveTo(85, 13, 102, 30, 102, 58);
      x.lineTo(102, 110);
      [83, 64, 45, 26].forEach((ex, i) => x.quadraticCurveTo(ex + 9.5, i % 2 ? 116 : 98, ex, 110));
      x.closePath();
    };
    sticker(x, sheet, () => {
      sheet();
      const g = x.createRadialGradient(50, 36, 4, 64, 64, 66);
      g.addColorStop(0, '#ffffff');
      g.addColorStop(0.45, fill);
      g.addColorStop(1, shade(fill, 0.78));
      x.fillStyle = g; x.fill();
      x.lineWidth = 3.5; x.strokeStyle = INK; x.stroke();
      x.fillStyle = INK;
      x.beginPath(); x.ellipse(50, 55, 6.5, 9.5, 0, 0, 7); x.ellipse(78, 55, 6.5, 9.5, 0, 0, 7); x.fill();
      x.beginPath(); x.ellipse(64, 80, 7.5, 10, 0, 0, 7); x.fill();
      x.fillStyle = '#fff'; x.beginPath(); x.arc(52, 51, 2.2, 0, 7); x.arc(80, 51, 2.2, 0, 7); x.fill();
      x.fillStyle = 'rgba(255,79,152,.35)'; x.beginPath(); x.ellipse(38, 70, 6, 3.5, 0, 0, 7); x.ellipse(90, 70, 6, 3.5, 0, 0, 7); x.fill();
    });
    return c;
  };
  // Spider: drops on its thread and shrinks your bag (the celery's job)
  const makeSpider = () => {
    const [c, x] = canvas128();
    const body = () => { x.beginPath(); x.arc(64, 74, 23, 0, 7); x.moveTo(78, 48); x.arc(64, 48, 14, 0, 7); };
    const legs = (w, col) => {
      x.lineWidth = w; x.strokeStyle = col;
      [[-1, 60, 30, 46, 14, 58], [-1, 68, 24, 66, 10, 82], [-1, 78, 26, 88, 16, 104], [-1, 86, 34, 100, 30, 118]].forEach(([, y0, kx, ky, ex, ey]) => {
        [[64 - 16, kx, ex], [64 + 16, 128 - kx, 128 - ex]].forEach(([sx, mx, fx]) => { x.beginPath(); x.moveTo(sx, y0); x.lineTo(mx, ky); x.lineTo(fx, ey); x.stroke(); });
      });
    };
    x.save(); x.translate(0, 6); legs(12, 'rgba(20,11,18,.3)'); x.restore();
    legs(11, '#fffefa');
    x.lineWidth = 4; x.strokeStyle = '#d9d4e6'; x.beginPath(); x.moveTo(64, 0); x.lineTo(64, 34); x.stroke();
    sticker(x, body, () => {
      legs(5, INK);
      body();
      const g = x.createRadialGradient(56, 60, 3, 64, 70, 34);
      g.addColorStop(0, '#6b4a86'); g.addColorStop(0.5, '#3b2650'); g.addColorStop(1, '#1f1230');
      x.fillStyle = g; x.fill();
      x.lineWidth = 3.5; x.strokeStyle = INK; x.stroke();
      x.fillStyle = '#ff8d2b'; x.beginPath(); x.moveTo(64, 74); x.lineTo(57, 84); x.lineTo(64, 94); x.lineTo(71, 84); x.closePath(); x.fill();
      x.fillStyle = '#fff'; x.beginPath(); x.arc(57, 46, 6, 0, 7); x.arc(71, 46, 6, 0, 7); x.fill();
      x.fillStyle = INK; x.beginPath(); x.arc(58, 47, 3, 0, 7); x.arc(70, 47, 3, 0, 7); x.fill();
      x.lineWidth = 3; x.strokeStyle = INK; x.beginPath(); x.moveTo(50, 38); x.lineTo(60, 41); x.moveTo(78, 38); x.lineTo(68, 41); x.stroke();
      x.fillStyle = '#fffefa'; x.beginPath(); x.moveTo(60, 57); x.lineTo(62, 63); x.lineTo(64, 57); x.moveTo(64, 57); x.lineTo(66, 63); x.lineTo(68, 57); x.fill();
    });
    return c;
  };
  // Cobweb: a sticky ball of web that glues your hand in place for a second (the ice cube's job)
  const makeWeb = () => {
    const [c, x] = canvas128();
    const disc = () => { x.beginPath(); x.arc(64, 64, 48, 0, 7); };
    sticker(x, disc, () => {
      disc();
      const g = x.createRadialGradient(54, 50, 4, 64, 64, 50);
      g.addColorStop(0, '#ffffff'); g.addColorStop(1, '#c8c2d8');
      x.fillStyle = g; x.fill();
      x.lineWidth = 3.5; x.strokeStyle = INK; x.stroke();
      x.save(); disc(); x.clip();
      x.strokeStyle = 'rgba(20,11,18,.72)'; x.lineWidth = 2.2;
      const spokes = 9;
      for (let i = 0; i < spokes; i++) { const a = (i / spokes) * Math.PI * 2 + 0.2; x.beginPath(); x.moveTo(64, 64); x.lineTo(64 + Math.cos(a) * 50, 64 + Math.sin(a) * 50); x.stroke(); }
      [12, 22, 32, 42].forEach((r) => {
        x.beginPath();
        for (let i = 0; i <= spokes; i++) {
          const a = (i / spokes) * Math.PI * 2 + 0.2;
          const a0 = ((i - 0.5) / spokes) * Math.PI * 2 + 0.2;
          const px = 64 + Math.cos(a) * r, py = 64 + Math.sin(a) * r;
          if (!i) x.moveTo(px, py); else x.quadraticCurveTo(64 + Math.cos(a0) * r * 0.86, 64 + Math.sin(a0) * r * 0.86, px, py);
        }
        x.stroke();
      });
      x.restore();
    });
    return c;
  };
  // The +5 bonus: the Target bullseye
  const makeBullseye = () => {
    const [c, x] = canvas128();
    const disc = () => { x.beginPath(); x.arc(64, 64, 50, 0, 7); };
    sticker(x, disc, () => {
      x.fillStyle = '#cc0000'; disc(); x.fill();
      x.fillStyle = '#ffffff'; x.beginPath(); x.arc(64, 64, 33, 0, 7); x.fill();
      x.fillStyle = '#cc0000'; x.beginPath(); x.arc(64, 64, 16.5, 0, 7); x.fill();
    });
    return c;
  };
  // The hand that holds the bag. Two layers: forearm, wristband and the back of the hand sit behind
  // the bag; the fingers, knuckles and thumb wrap over its front. Sprite box 200x260, grip point (100, 50),
  // the bag's bottom edge sits at y = 64.
  const mixHex = (a, b, t) => {
    const p = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16));
    const [x, y] = [p(a), p(b)];
    return `#${x.map((v, i) => Math.round(v + (y[i] - v) * t).toString(16).padStart(2, '0')).join('')}`;
  };
  const makeHand = (tone, monster) => {
    tone = /^#[0-9a-f]{6}$/i.test(tone || '') ? tone : '#e0a07a';
    const lite = mixHex(tone, '#ffffff', 0.16);
    const dark = mixHex(tone, '#3a1a10', 0.16);
    const deep = mixHex(tone, '#3a1a10', 0.32);
    const nail = monster ? mixHex(tone, '#2e2a22', 0.45) : mixHex(tone, '#ffffff', 0.45);
    // monster: cross-stitched scars and neck-bolt style bolts at the wrist instead of a sweatband
    const stitch = (pts, n) => {
      const [a, b] = pts;
      const seam = `<path d="M${a[0]} ${a[1]} L${b[0]} ${b[1]}" stroke="${mixHex(tone, '#3a1a10', 0.55)}" stroke-width="2.6" stroke-linecap="round" fill="none"/>`;
      const dx = b[0] - a[0], dy = b[1] - a[1], len = Math.hypot(dx, dy), nx = -dy / len, ny = dx / len;
      const xs = Array.from({ length: n }, (_, i) => {
        const t = (i + 0.5) / n, cx = a[0] + dx * t, cy = a[1] + dy * t;
        return `<path d="M${(cx - nx * 4 - dx / len * 1.5).toFixed(1)} ${(cy - ny * 4 - dy / len * 1.5).toFixed(1)} L${(cx + nx * 4 + dx / len * 1.5).toFixed(1)} ${(cy + ny * 4 + dy / len * 1.5).toFixed(1)}" stroke="#b05a6e" stroke-width="2.2" stroke-linecap="round"/>`;
      }).join('');
      return seam + xs;
    };
    const bolt = (x0, dir) => `<g>
      <rect x="${dir < 0 ? x0 - 14 : x0}" y="134" width="14" height="10" rx="2" fill="#b8bcc6" stroke="${INK}" stroke-width="3"/>
      <rect x="${dir < 0 ? x0 - 21 : x0 + 12}" y="131" width="9" height="16" rx="2.5" fill="#9aa0ab" stroke="${INK}" stroke-width="3"/>
      <path d="M${dir < 0 ? x0 - 18 : x0 + 15} 135 v8" stroke="#fff" stroke-width="1.6" opacity=".6"/>
    </g>`;
    const S = `stroke="${INK}" stroke-width="4.5" stroke-linejoin="round" stroke-linecap="round"`;
    const defs = `<defs>
      <linearGradient id="arm" x1="0" x2="1"><stop offset="0" stop-color="${lite}"/><stop offset=".55" stop-color="${tone}"/><stop offset="1" stop-color="${dark}"/></linearGradient>
      <linearGradient id="fin" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${lite}"/><stop offset=".55" stop-color="${tone}"/><stop offset="1" stop-color="${dark}"/></linearGradient>
      <linearGradient id="hand" gradientUnits="userSpaceOnUse" x1="0" y1="56" x2="0" y2="130"><stop offset="0" stop-color="${tone}"/><stop offset="1" stop-color="${dark}"/></linearGradient>
      <filter id="soft" x="-30%" y="-30%" width="160%" height="160%"><feGaussianBlur stdDeviation="2.4"/></filter>
      <clipPath id="below"><rect x="0" y="66" width="200" height="200"/></clipPath>
      <clipPath id="palm"><path d="M48 62 C48 94 62 114 78 130 L122 130 C138 114 152 94 152 62 Z"/></clipPath>
    </defs>`;
    // cx, base, width, height, tilt (pinky first so the index sits on top)
    const fingers = [[136, 84, 21, 48, 9], [115, 84, 24, 59, 3], [91, 84, 26, 64, -2], [67, 84, 25, 57, -8]];
    const fingerPath = (cx, base, w, h) => {
      const top = base - h;
      const r = w / 2 - 1.5;
      return `M${cx - w / 2} ${base} L${cx - r} ${top + r} A${r} ${r} 0 0 1 ${cx + r} ${top + r} L${cx + w / 2} ${base} Z`;
    };
    const finger = ([cx, base, w, h, tilt]) => {
      const top = base - h;
      return `<g transform="rotate(${tilt} ${cx} ${base})">
        <path d="${fingerPath(cx, base, w, h)}" fill="url(#fin)" ${S}/>
        <rect x="${cx - w * 0.3}" y="${top + 4}" width="${w * 0.6}" height="${h * 0.24}" rx="${w * 0.28}" fill="${nail}" stroke="${dark}" stroke-width="1.6"/>
        <path d="M${cx - w * 0.16} ${top + 7} q${w * 0.12} -1.5 ${w * 0.22} 0" stroke="#fff" stroke-width="2" opacity=".75" fill="none" stroke-linecap="round"/>
        <path d="M${cx - w * 0.28} ${top + h * 0.5} q${w * 0.28} 3.6 ${w * 0.56} 0" stroke="${deep}" stroke-width="2.2" fill="none" stroke-linecap="round"/>
        <path d="M${cx - w * 0.2} ${top + h * 0.72} q${w * 0.2} 2.6 ${w * 0.4} 0" stroke="${deep}" stroke-width="1.8" fill="none" stroke-linecap="round" opacity=".8"/>
      </g>`;
    };
    const shadow = fingers.map(([cx, base, w, h, tilt]) => `<path transform="translate(3 6) rotate(${tilt} ${cx} ${base})" d="${fingerPath(cx, base, w, h)}" fill="${INK}" opacity=".28"/>`).join('');
    const outline = 'M48 62 C48 94 62 114 78 130 L122 130 C138 114 152 94 152 62 Z';
    const knuckles = 'M46 79 Q54 68 66 72 Q78 64 91 70 Q103 63 115 70 Q127 65 137 72 Q148 69 154 79';
    const back = `${defs}
      <path d="M77 128 C75 170 71 215 66 272 L134 272 C129 215 125 170 123 128 Z" fill="url(#arm)" ${S}/>
      <path d="M118 152 C121 188 124 226 126 270" fill="none" stroke="${deep}" stroke-width="3" opacity=".4" stroke-linecap="round"/>
      <path d="M84 152 C82 190 80 230 78 270" fill="none" stroke="#fff" stroke-width="3" opacity=".22" stroke-linecap="round"/>
      <path d="${outline}" fill="url(#hand)" ${S}/>
      <path d="M72 88 L84 122 M96 88 L98 122 M121 88 L112 122" stroke="${lite}" stroke-width="3" opacity=".6" fill="none" stroke-linecap="round"/>
      ${monster ? `${stitch([[66, 100], [118, 114]], 6)}${stitch([[77, 140], [123, 140]], 6)}${bolt(77, -1)}${bolt(123, 1)}` : `
      <rect x="68" y="112" width="64" height="33" rx="11" fill="#ff4f98"/>
      <rect x="68" y="121.5" width="64" height="6" fill="#ffb32c"/>
      <rect x="68" y="131" width="64" height="3.5" fill="#fffefa"/>
      ${Array.from({ length: 12 }, (_, i) => `<path d="M${73 + i * 5} 114.5 v4.5 M${74.5 + i * 5} 138 v4.5" stroke="${INK}" stroke-width="1.4" opacity=".14"/>`).join('')}
      <rect x="68" y="112" width="64" height="33" rx="11" fill="none" ${S}/>`}`;
    const front = `${defs}
      <g filter="url(#soft)">${shadow}</g>
      ${fingers.map(finger).join('')}
      <g clip-path="url(#palm)">
        <path d="${knuckles} L154 100 L46 100 Z" fill="url(#hand)"/>
        <path d="${knuckles}" fill="none" ${S}/>
        ${[[66, 73], [91, 72], [115, 72], [137, 74]].map(([x, y]) => `<ellipse cx="${x}" cy="${y + 2}" rx="5.5" ry="2.6" fill="#fff" opacity=".32"/>`).join('')}
      </g>
      <path d="${outline}" fill="none" ${S} clip-path="url(#below)"/>
      <path d="M58 106 C45 100 35 86 36 71 C37 57 49 51 57 58 C62 63 63 72 66 82 C66 92 63 100 58 106 Z" fill="url(#hand)"/>
      <path d="M58 106 C45 100 35 86 36 71 C37 57 49 51 57 58 C62 63 63 72 66 82" fill="none" ${S}/>
      <g transform="rotate(-24 46 62)"><rect x="40" y="55" width="12" height="11" rx="5" fill="${nail}" stroke="${dark}" stroke-width="1.6"/></g>
      <path d="M40 80 q6 3 11 0" stroke="${deep}" stroke-width="2.2" fill="none" stroke-linecap="round"/>
      ${monster ? `<g transform="rotate(-2 91 84)">${stitch([[84, 52], [98, 46]], 3)}</g>` : ''}`;
    const svg = (body) => `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="520" viewBox="0 0 200 260">${body}</svg>`;
    const img = (body) => loadImg(`data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg(body))}`);
    return Promise.all([img(back), img(front)]).then(([b, f]) => (b && f ? { back: b, front: f } : null));
  };
  // A recolored copy of a hand layer (red hot for Heat mode, icy for a brain freeze)
  const tinted = (img, paint, alpha) => {
    const c = document.createElement('canvas');
    c.width = img.width || 400;
    c.height = img.height || 520;
    const x = c.getContext('2d');
    x.drawImage(img, 0, 0, c.width, c.height);
    x.globalCompositeOperation = 'source-atop';
    x.globalAlpha = alpha;
    x.fillStyle = typeof paint === 'function' ? paint(x, c) : paint;
    x.fillRect(0, 0, c.width, c.height);
    return c;
  };
  const hotPaint = (x, c) => {
    const g = x.createLinearGradient(0, 0, 0, c.height);
    g.addColorStop(0, '#ffe27a');
    g.addColorStop(0.35, '#ff8d2b');
    g.addColorStop(1, '#df1f3d');
    return g;
  };

  const ART = { candies: [], pepper: null, bags: {}, bland: [], celery: null, ice: null, hand: null, hot: null, icy: null };
  const artReady = Promise.all([
    Promise.all((CFG.candies || []).map(loadImg)).then((a) => { ART.candies = a.filter(Boolean); }),
    loadImg(CFG.pepper).then((i) => { ART.pepper = i; }),
    ...Object.entries(CFG.bags || {}).map(([k, src]) => loadImg(src).then((i) => { ART.bags[k] = i; })),
    makeHand(CFG.handTone, HW).then((h) => {
      ART.hand = h;
      if (!h) return;
      try {
        ART.hot = { back: tinted(h.back, hotPaint, 0.62), front: tinted(h.front, hotPaint, 0.62) };
        const icy = HW ? '#ece8f6' : '#c9efff';
        ART.icy = { back: tinted(h.back, icy, HW ? 0.5 : 0.6), front: tinted(h.front, icy, HW ? 0.5 : 0.6) };
      } catch (_) {}
    }),
    document.fonts?.load ? Promise.all([document.fonts.load('900 40px Inter'), document.fonts.load('800 16px Figtree')]).catch(() => {}) : null,
  ]);
  if (HW) {
    ART.bland = [['#f4f0ff', 3], ['#eafff0', 17], ['#fff0f6', 29]].map(([c, s]) => makeGhost(c, s));
    ART.celery = makeSpider();
    ART.ice = makeWeb();
    ART.bonus = makeBullseye();
  } else {
    ART.bland = [['#dfe2c4', 7], ['#f3d3cf', 31], ['#f2e4b8', 59]].map(([c, s]) => makeBland(c, s));
    ART.celery = makeCelery();
    ART.ice = makeIce();
  }
  $$('[data-ccg-icon]').forEach((el) => {
    const k = el.dataset.ccgIcon;
    const c = k === 'bland' ? ART.bland[0] : ART[k];
    if (c) el.src = c.toDataURL();
  });

  /* Elements */
  const stage = $('[data-ccg-stage]');
  const canvas = $('[data-ccg-canvas]');
  const ctx = canvas.getContext('2d');
  const raysEl = $('.ccg-rays');
  const screens = Object.fromEntries($$('[data-ccg-screen]').map((el) => [el.dataset.ccgScreen, el]));
  const hud = {
    speed: $('[data-ccg-speed]'),
    label: $('[data-ccg-label]'),
    fill: $('[data-ccg-fill]'),
    meter: $('[data-ccg-meter]'),
    goal: $('[data-ccg-goal]'),
    goalLabel: $('[data-ccg-goal-label]'),
    strikes: $$('[data-ccg-strikes] i'),
  };
  const countdownEl = $('[data-ccg-countdown]');
  const pausedEl = $('[data-ccg-paused]');
  const toastEl = $('[data-ccg-toast]');
  const muteBtn = $('[data-ccg-mute]');
  const shopUrl = CFG.shopUrl || '/collections/all';
  const shopHref = CODE ? `/discount/${encodeURIComponent(CODE)}?redirect=${encodeURIComponent(shopUrl)}` : shopUrl;

  const show = (name) => {
    stage.scrollTop = 0;
    Object.entries(screens).forEach(([k, el]) => { el.hidden = k !== name; });
    stage.classList.toggle('is-intro', name === 'intro');
    if (name === 'intro') { stage.classList.remove('is-driven'); if (raysEl) raysEl.style.transform = ''; }
    const focusEl = name === 'lose' && screens[name]?.querySelector('[data-ccg-retry]');
    if (focusEl) setTimeout(() => focusEl.focus({ preventScroll: true }), 450);
  };
  let toastTimer = 0;
  const toast = (msg) => {
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-on'), 2600);
  };
  const syncBestChip = () => {
    const chip = $('[data-ccg-best-chip]');
    if (chip) chip.textContent = saved.bestScore ? `Best ${saved.bestScore}` : 'Level 1';
  };

  /* Layout */
  let W = 0, H = 0, DPR = 1, FLOOR = 30, R = 26, BASE_W = 100, HAND_W = 140, GRIP_Y = 600;
  const bag = { key: Object.keys(CFG.bags || {})[0] || 'watermelon-bites', img: null, x: 0, tx: 0, vx: 0, tilt: 0, squash: 0, scale: 1, size: 1, shown: 1 };
  // Bag geometry for the current size. The hand never shrinks, only the bag in it.
  const dims = () => {
    const w = BASE_W * bag.scale * bag.shown;
    const h = w * (bag.img ? bag.img.height / bag.img.width : 1.36);
    const k = HAND_W / 200;
    const bottom = GRIP_Y + 14 * k;
    const top = bottom - h;
    return { w, h, k, top, bottom, half: w / 2, mouth: top + h * 0.1, badHalf: w / 2 / bag.scale };
  };
  const resize = () => {
    const r = stage.getBoundingClientRect();
    W = r.width;
    H = r.height;
    DPR = Math.min(2, window.devicePixelRatio || 1);
    canvas.width = Math.round(W * DPR);
    canvas.height = Math.round(H * DPR);
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    R = clamp(W * 0.068, 22, 34);
    FLOOR = ($('.ccg-ticker')?.offsetHeight || 34) - 4;
    BASE_W = clamp(W * 0.25, 84, 124);
    HAND_W = BASE_W * 1.42;
    GRIP_Y = H - FLOOR - clamp(H * 0.09, 56, 80);
    const half = (BASE_W * bag.scale) / 2;
    bag.x = clamp(bag.x || W / 2, half, W - half);
    bag.tx = clamp(bag.tx || W / 2, half, W - half);
  };

  /* Tuning. tools/sim.mjs plays these exact curves with bots (keep in sync).
     Bots reach the goal ~96% of the time in ~13s; runs last 35 to 70s and keep speeding up to x4. */
  const ASSIST = [
    { scale: 1, bad: 1, fall: 1, label: '' },
    { scale: 1.2, bad: 0.72, fall: 1.1, label: HW ? 'XL bag unlocked. Fewer ghosts.' : 'XL bag unlocked. Fewer bland gummies.' },
    { scale: 1.4, bad: 0.5, fall: 1.2, label: 'XXL bag unlocked. You got this.' },
  ];
  const RAMP = 0.045;
  const MAX_SPEED = 4;
  const speedAt = (t) => Math.min(MAX_SPEED, 1 + RAMP * t);
  const EVERY = {
    chew: (t) => Math.max(0.28, 0.8 / (1 + 0.025 * t)),
    bland: (t) => Math.max(0.5, 1.6 / (1 + 0.03 * t)),
    celery: (t) => Math.max(1.4, 5 / (1 + 0.03 * t)),
    ice: (t) => Math.max(2, 7 / (1 + 0.03 * t)),
  };
  const START = { chew: 0, bland: 1.2, celery: 9, ice: 16 };
  const BAD = new Set(['bland', 'celery', 'ice']);
  const HEAT_SECONDS = 4.5;
  const FREEZE_SECONDS = 1.3;
  const SHRINK = 0.85;
  const MIN_SIZE = 0.55;
  const STREAKS = HW
    ? { 5: 'Spooky!', 10: 'Monstrous!', 20: 'Fright night!', 30: 'Unholy!', 50: 'Legend!' }
    : { 5: 'Spicy!', 10: 'On fire!', 20: 'Chili legend!', 30: 'Unstoppable!', 50: 'Menace!' };
  const SPEED_CALLS = HW
    ? ['Faster!', 'Spookier!', 'Witching hour!', 'Chaos!', 'Possessed!', 'Max fright!']
    : ['Faster!', 'Hotter!', 'Spicier!', 'Chaos!', 'Inferno!', 'Max heat!'];
  const BLANDS = HW ? ['Boo!', 'Ghosted!', 'Spooked!', 'Eek!', 'Nope!'] : ['Bland!', 'Ew, plain!', 'No flavor!', 'Boring!', 'Zero heat!'];
  // Halloween bonus: the bullseye drops from 8s in, then every 10 to 15s (the API's score cap assumes this)
  const BONUS = 5;
  const FLAKES = ['#df1f3d', '#ff8d66', '#ffb32c', '#8a1c10', '#fffefa'];
  const HOT = ['#ffb32c', '#ff8d66', '#df1f3d', '#d6fb51'];
  const EMBER = ['#ffb32c', '#ff8d66', '#fff6d0', '#ffe27a'];
  // Where the flames sit on the burning hand, in hand-sprite units: [x, base y, height]
  const FINGER_FLAMES = [[42, 62, 42], [56, 38, 56], [73, 28, 70], [92, 22, 82], [113, 28, 70], [133, 38, 58], [152, 60, 42]];
  const ARM_FLAMES = [[50, 96, 44, -0.5], [150, 96, 44, 0.5], [62, 122, 40, -0.4], [138, 122, 40, 0.4], [74, 140, 34, -0.25], [126, 140, 34, 0.25]];
  // Candies peeking out of the bag as it fills toward the goal (x and y as fractions of the bag)
  const PILE = [[-0.2, 0.07], [0.2, 0.08], [0, 0.05], [-0.3, 0.01], [0.29, 0], [0.09, -0.03], [-0.11, -0.04], [-0.21, -0.09], [0.19, -0.1], [0, -0.14]]
    .map(([dx, dy], i) => ({ dx, dy, rot: ((i * 1.7) % 2) - 1, img: i }));

  const G = {
    state: 'intro', t: 0, score: 0, lives: LIVES, streak: 0, items: [], parts: [], texts: [], next: {},
    heat: 0, freeze: 0, shake: 0, tier: 0, goalHit: false, goalAt: null, bestBefore: 0, newBest: false,
    assist: 0, attempt: 0, lastChewX: null, lastChewT: -9, raysA: 0,
    clock: 0, fireBurst: 0, kick: 0, ticket: null, posted: false, rank: null,
  };
  const keys = { left: false, right: false };

  /* Spawning */
  const spawnX = (avoid) => {
    const m = R + 8;
    for (let i = 0; i < 8; i++) {
      const x = rand(m, W - m);
      if (avoid == null || Math.abs(x - avoid) > R * 3) return x;
    }
    return rand(m, W - m);
  };
  const spawn = (type) => {
    const d = dims();
    const floaty = type === 'pepper' || type === 'pouch';
    const vy = (d.mouth / ((2.8 / speedAt(G.t)) * ASSIST[G.assist].fall)) * rand(0.92, 1.1) * (floaty ? 0.82 : 1);
    const it = { type, x: 0, y: -R * 1.4, vx: 0, vy, rot: rand(0, 6.28), vr: rand(-1.8, 1.8), r: R, img: null, dead: false, out: false, wob: rand(0, 6) };
    if (type === 'chew') {
      it.x = spawnX(null);
      it.img = pick(ART.candies);
      G.lastChewX = it.x;
      G.lastChewT = G.t;
    } else if (BAD.has(type)) {
      // never drop a hazard right on top of a fresh chew: there is always a fair line
      it.x = spawnX(G.t - G.lastChewT < 0.55 ? G.lastChewX : null);
      it.img = type === 'bland' ? pick(ART.bland) : ART[type];
      if (type !== 'bland') it.vr *= 0.5;
    } else if (type === 'bonus') {
      it.x = spawnX(null);
      it.img = ART.bonus;
      it.r = R * 0.95;
      it.vr = 0;
      it.vy *= 1.12;
    } else {
      it.x = spawnX(null);
      it.img = type === 'pepper' ? ART.pepper : bag.img;
      it.r = R * 0.95;
      it.vr = 0;
    }
    G.items.push(it);
  };

  /* Juice */
  const flakes = (x, y, n, palette = FLAKES) => {
    for (let i = 0; i < n; i++) {
      G.parts.push({ x, y, vx: rand(-230, 230), vy: rand(-440, -140), g: 950, life: rand(0.45, 0.85), t: 0, s: rand(3, 6.5), c: pick(palette), rot: rand(0, 6) });
    }
  };
  const floatText = (text, x, y, o = {}) => {
    G.texts.push({ text, x, y, t: 0, life: o.big ? 1.05 : 0.7, size: o.size || 24, color: o.color || '#fffefa', big: !!o.big, tilt: o.big ? rand(-0.12, 0.08) : 0 });
  };
  const callout = (text, color = '#ffb32c', size = 46) => {
    G.texts = G.texts.filter((t) => !t.big);
    floatText(text, W / 2, H * 0.36, { size, color, big: true });
  };
  const bump = (el) => {
    el.classList.remove('is-bump');
    void el.offsetWidth;
    el.classList.add('is-bump');
  };
  const flash = () => {
    stage.classList.remove('is-hit');
    void stage.offsetWidth;
    stage.classList.add('is-hit');
  };
  let shownHud = '';
  const updateHud = () => {
    const sp = speedAt(G.t).toFixed(1);
    let label, goal, goalCls, fill;
    if (!G.goalHit) {
      label = `<b>${G.score}</b>&nbsp;/&nbsp;${GOAL}`;
      fill = G.score / GOAL;
      goal = 'Free';
      goalCls = '';
    } else {
      label = `<b>${G.score}</b>`;
      const best = G.bestBefore;
      const lead = BOARD ? leaderScore : 0;
      const target = Math.max(best, lead);
      if (target && G.score > target) { goal = lead > best ? '#1!' : 'New!'; goalCls = 'is-new'; fill = 1; }
      else if (target) { goal = `${lead > best ? '#1' : 'Best'}<i>${target}</i>`; goalCls = 'is-best'; fill = G.score / target; }
      else { goal = 'Go!'; goalCls = 'is-new'; fill = 1; }
    }
    const key = `${sp}|${label}|${goal}|${G.lives}`;
    if (key === shownHud) return;
    shownHud = key;
    hud.speed.textContent = `x${sp}`;
    hud.label.innerHTML = label;
    hud.goalLabel.innerHTML = goal;
    hud.goal.className = `ccg-meter__goal ${goalCls}`;
    hud.fill.style.width = `${clamp(fill, 0, 1) * 100}%`;
    hud.fill.classList.toggle('is-full', fill >= 1);
    hud.strikes.forEach((s, i) => s.classList.toggle('is-hit', i < LIVES - G.lives));
  };

  /* Catching */
  const knockOut = (it) => {
    it.dead = false;
    it.out = true;
    it.vy = -560;
    it.vx = (it.x < bag.x ? -1 : 1) * rand(170, 270);
    it.vr = rand(-5, 5);
  };
  // good stuff gets slurped into the bag instead of just vanishing
  const suck = (it) => {
    it.dead = false;
    it.sucked = 0.14;
    it.sx = it.x;
    it.sy = it.y;
  };
  const fireRing = (x, y) => {
    for (let i = 0; i < 34; i++) {
      const a = (i / 34) * Math.PI * 2;
      const v = rand(220, 420);
      G.parts.push({ kind: 'ember', x, y, vx: Math.cos(a) * v, vy: Math.sin(a) * v - 120, g: 200, life: rand(0.45, 0.8), t: 0, s: rand(3, 6), c: pick(EMBER) });
    }
  };
  const smokePuff = () => {
    for (let i = 0; i < 12; i++) {
      G.parts.push({ kind: 'smoke', x: bag.x + rand(-34, 34), y: GRIP_Y + rand(-30, 50), vx: rand(-25, 25), vy: rand(-80, -40), g: -10, life: rand(0.8, 1.3), t: 0, s: rand(9, 15), c: '#4a3f40' });
    }
  };
  // passing this week's top score mid-run gets its own moment
  const passLead = () => {
    if (!BOARD || !leaderScore || G.passedLead || !G.goalHit || G.score <= leaderScore) return false;
    G.passedLead = true;
    G.newBest = G.newBest || !!(G.bestBefore && G.score > G.bestBefore);
    callout('Top score this week!', '#34f466', 38);
    Sound.win();
    vibrate([30, 40, 30]);
    return true;
  };
  const catchItem = (it) => {
    it.dead = true;
    const d = dims();
    const mx = clamp(it.x, bag.x - d.w * 0.32, bag.x + d.w * 0.32);
    const my = d.top + d.h * 0.06;
    if (it.type === 'chew') {
      suck(it);
      G.score += 1;
      G.streak += 1;
      G.kick = 1;
      bag.squash = 1;
      flakes(mx, my, 9);
      floatText(G.heat > 0 ? '+1 🔥' : '+1', mx, my - 12, { size: 22 });
      Sound.chew(G.streak);
      bump(hud.meter);
      if (!G.goalHit && G.score >= GOAL) return reachGoal();
      if (passLead()) return;
      if (G.goalHit && !G.newBest && G.bestBefore && G.score > G.bestBefore) {
        G.newBest = true;
        callout('New high score!', '#d6fb51', 40);
        Sound.refill();
        return;
      }
      if (STREAKS[G.streak]) callout(STREAKS[G.streak]);
      else if (!G.goalHit && GOAL - G.score === 5) callout('5 more!', '#d6fb51');
    } else if (it.type === 'pepper') {
      suck(it);
      G.heat = HEAT_SECONDS;
      G.fireBurst = 1;
      G.kick = 1;
      stage.classList.add('is-heat');
      flakes(mx, my, 26, HOT);
      fireRing(bag.x, GRIP_Y);
      callout('Hand on fire!', '#ffb32c', 46);
      Sound.pepper();
      vibrate(30);
    } else if (it.type === 'pouch') {
      suck(it);
      bag.size = 1;
      bag.squash = 1;
      flakes(mx, my, 20, ['#d6fb51', '#55c95a', '#fffefa']);
      callout('Big bag!', '#d6fb51');
      Sound.refill();
    } else if (it.type === 'bonus') {
      suck(it);
      G.score += BONUS;
      G.streak += 1;
      G.kick = 1;
      bag.squash = 1;
      flakes(mx, my, 26, ['#cc0000', '#fffefa', '#ff4f4f']);
      floatText(`+${BONUS}`, mx, my - 12, { size: 30, color: '#ff5a5a' });
      callout(`Bullseye! +${BONUS}`, '#ff5a5a', 46);
      Sound.refill();
      vibrate(30);
      bump(hud.meter);
      if (!G.goalHit && G.score >= GOAL) return reachGoal();
      if (passLead()) return;
      if (G.goalHit && !G.newBest && G.bestBefore && G.score > G.bestBefore) { G.newBest = true; callout('New high score!', '#d6fb51', 40); }
    } else if (G.heat > 0) {
      flakes(mx, my, 16, ['#3a2f2f', '#6b5e57', '#140b12', '#ffb32c']);
      floatText('Toasted!', mx, my - 26, { size: 28, color: '#ffb32c' });
      Sound.toast();
    } else if (it.type === 'bland') {
      G.lives -= 1;
      G.streak = 0;
      G.shake = 1;
      G.kick = -1;
      knockOut(it);
      floatText(pick(BLANDS), mx, my - 34, { size: 32 });
      flash();
      Sound.bland();
      vibrate(90);
      if (G.lives <= 0) gameOver();
    } else if (it.type === 'celery') {
      bag.size = Math.max(MIN_SIZE, bag.size * SHRINK);
      G.shake = 0.5;
      knockOut(it);
      callout(HW ? 'Spider! Bag shrunk.' : 'Celery?! Bag shrunk.', HW ? '#cfa8ff' : '#c9e88a', 34);
      Sound.crunch();
      vibrate(40);
    } else if (it.type === 'ice') {
      G.freeze = FREEZE_SECONDS;
      stage.classList.add('is-frozen');
      flakes(mx, my, 18, HW ? ['#ffffff', '#e2dcef', '#bdb4d1'] : ['#effbff', '#bfe9ff', '#8fd3f5']);
      callout(HW ? 'Webbed!' : 'Brain freeze!', HW ? '#ece8f6' : '#bfe9ff', 42);
      Sound.freeze();
      vibrate(60);
    }
  };

  /* Simulation step. mode: play (everything), fx (bag and effects only), over (things fall, nothing scores) */
  const step = (dt, mode) => {
    const live = mode === 'play';
    if (live) {
      G.t += dt;
      const t = G.t;
      for (const type of ['chew', 'bland', 'celery', 'ice']) {
        if (t < START[type]) continue;
        G.next[type] -= dt;
        if (G.next[type] <= 0) {
          spawn(type);
          let gap = EVERY[type](t) * rand(0.75, 1.25);
          if (type !== 'chew') gap /= ASSIST[G.assist].bad;
          if (type === 'bland' && G.lives === 1) gap *= 1.3;
          G.next[type] = gap;
        }
      }
      G.next.pepper -= dt;
      if (G.next.pepper <= 0) { spawn('pepper'); G.next.pepper = rand(11, 15); }
      if (HW && ART.bonus && (G.next.bonus -= dt) <= 0) { spawn('bonus'); G.next.bonus = rand(10, 15); }
      if (bag.size < 1) {
        G.next.pouch -= dt;
        if (G.next.pouch <= 0) { spawn('pouch'); G.next.pouch = rand(6, 8); }
      }
      if (G.heat > 0 && (G.heat -= dt) <= 0) { G.heat = 0; stage.classList.remove('is-heat'); smokePuff(); }
      if (G.heat > 0 && Math.random() < dt * 40) {
        G.parts.push({ kind: 'ember', x: bag.x + rand(-1, 1) * HAND_W * 0.32, y: GRIP_Y + rand(-20, 70), vx: rand(-30, 30), vy: rand(-190, -90), g: -60, life: rand(0.5, 0.9), t: 0, s: rand(2.5, 4.5), c: pick(EMBER) });
      }
      if (G.freeze > 0 && (G.freeze -= dt) <= 0) { G.freeze = 0; stage.classList.remove('is-frozen'); }
      const tier = Math.floor((speedAt(t) - 1) / 0.5 + 1e-6);
      if (tier > G.tier) {
        G.tier = tier;
        callout(SPEED_CALLS[Math.min(tier, SPEED_CALLS.length) - 1], '#fffefa', 48);
        Sound.speedup();
        bump(hud.speed);
        for (let i = 0; i < 26; i++) G.parts.push({ kind: 'streak', x: rand(0, W), y: rand(-H * 0.3, H * 0.6), vx: 0, vy: rand(1100, 1600), g: 0, life: rand(0.25, 0.45), t: 0, s: rand(40, 100), c: '#fffefa' });
      }
    }

    // the hand
    const frozen = live && G.freeze > 0;
    if (!frozen) {
      if (keys.left) bag.tx -= 950 * dt;
      if (keys.right) bag.tx += 950 * dt;
    }
    const d = dims();
    bag.tx = clamp(bag.tx, d.half, W - d.half);
    const px = bag.x;
    if (!frozen) bag.x += (bag.tx - bag.x) * Math.min(1, dt * 24);
    else bag.tx = bag.x;
    bag.vx = (bag.x - px) / Math.max(dt, 0.001);
    bag.tilt += (clamp(bag.vx / 2600, -0.18, 0.18) - bag.tilt) * Math.min(1, dt * 12);
    bag.squash = Math.max(0, bag.squash - dt * 5);
    bag.shown += (bag.size - bag.shown) * Math.min(1, dt * 7);
    G.shake = Math.max(0, G.shake - dt * 3.2);
    G.fireBurst = Math.max(0, G.fireBurst - dt * 2);
    G.kick += (0 - G.kick) * Math.min(1, dt * 9);

    if (mode !== 'fx') {
      for (const it of G.items) {
        if (it.sucked != null) {
          it.sucked -= dt;
          const u = 1 - Math.max(0, it.sucked) / 0.14;
          it.x = lerp(it.sx, bag.x, u);
          it.y = lerp(it.sy, d.top + d.h * 0.2, u);
          it.scale = 1 - u * 0.85;
          if (it.sucked <= 0) it.dead = true;
          continue;
        }
        if (it.out) {
          it.vy += 1500 * dt;
          it.x += it.vx * dt;
          it.y += it.vy * dt;
          it.rot += it.vr * dt;
          if (it.y > H + 90) it.dead = true;
          continue;
        }
        if (live && G.heat > 0 && it.type === 'chew' && it.y > H * 0.2) {
          it.x += (bag.x - it.x) * Math.min(1, dt * 3.4);
          if (Math.random() < dt * 22) G.parts.push({ x: it.x + rand(-6, 6), y: it.y - it.r * 0.5, vx: rand(-20, 20), vy: rand(-110, -50), g: -40, life: 0.32, t: 0, s: rand(4, 7), c: pick(HOT), rot: 0 });
        }
        it.y += it.vy * dt;
        it.rot += it.vr * dt;
        if (it.type === 'pepper' || it.type === 'pouch') { it.wob += dt * 5; it.x += Math.sin(it.wob) * 46 * dt; }
        else if (it.type === 'bonus') it.wob += dt * 7;
        if (live && G.state === 'playing') {
          const dx = Math.abs(it.x - bag.x);
          // good stuff is caught generously; bad stuff only counts if it really drops in the top of the bag
          const hit = BAD.has(it.type)
            ? it.y >= d.mouth - it.r * 0.3 && it.y <= d.mouth + d.h * 0.2 && dx <= d.badHalf * 0.88
            : it.y >= d.mouth - it.r * 0.4 && it.y <= d.mouth + d.h * 0.45 && dx <= d.half + it.r * 0.3;
          if (hit) { catchItem(it); continue; }
        }
        if (it.y - it.r > H - FLOOR + 6) {
          it.dead = true;
          if (live && it.type === 'chew') {
            G.streak = 0;
            for (let i = 0; i < 6; i++) G.parts.push({ x: it.x, y: H - FLOOR - 2, vx: rand(-110, 110), vy: rand(-200, -70), g: 900, life: 0.4, t: 0, s: rand(2, 4), c: pick(FLAKES) });
          }
        }
      }
      G.items = G.items.filter((i) => !i.dead);
    }

    for (const p of G.parts) {
      p.t += dt;
      p.vy += p.g * dt;
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.rot = (p.rot || 0) + dt * 8;
    }
    G.parts = G.parts.filter((p) => p.t < p.life);
    for (const t of G.texts) t.t += dt;
    G.texts = G.texts.filter((t) => t.t < t.life);
    if (live) updateHud();
  };

  /* Drawing */
  const drawSprite = (img, x, y, size, rot) => {
    if (!img) return;
    const k = size / Math.max(img.width, img.height);
    ctx.save();
    ctx.translate(x, y);
    if (rot) ctx.rotate(rot);
    ctx.drawImage(img, (-img.width * k) / 2, (-img.height * k) / 2, img.width * k, img.height * k);
    ctx.restore();
  };
  // One cartoon flame: ink-outlined orange tongue with a yellow core, flickering on its own rhythm
  const flame = (x, y, h, w, lean, ph) => {
    const t = G.clock;
    const hh = h * (0.8 + 0.2 * Math.sin(t * 13 + ph * 2.1) + 0.08 * Math.sin(t * 29 + ph));
    const sway = Math.sin(t * 8 + ph) * w * 0.32 + lean * hh;
    const shape = (s) => {
      ctx.beginPath();
      ctx.moveTo(x - (w * s) / 2, y);
      ctx.quadraticCurveTo(x - w * s * 0.62 + sway * 0.3 * s, y - hh * s * 0.5, x + sway * s, y - hh * s);
      ctx.quadraticCurveTo(x + w * s * 0.62 + sway * 0.3 * s, y - hh * s * 0.5, x + (w * s) / 2, y);
      ctx.quadraticCurveTo(x, y + w * s * 0.3, x - (w * s) / 2, y);
      ctx.closePath();
    };
    const g = ctx.createLinearGradient(0, y, 0, y - hh);
    g.addColorStop(0, '#df1f3d');
    g.addColorStop(0.45, '#ff6a2b');
    g.addColorStop(1, '#ffb32c');
    shape(1);
    ctx.fillStyle = g;
    ctx.fill();
    ctx.lineWidth = 2.2;
    ctx.lineJoin = 'round';
    ctx.strokeStyle = INK;
    ctx.stroke();
    shape(0.58);
    ctx.fillStyle = '#ffe27a';
    ctx.fill();
    shape(0.3);
    ctx.fillStyle = '#fff6d0';
    ctx.fill();
  };
  const fireLevel = () => (G.heat > 0 ? Math.min(1, G.heat / 0.6) * (1 + G.fireBurst * 0.9) : 0);
  const drawPlayer = () => {
    const d = dims();
    const k = d.k;
    const pivotY = GRIP_Y + 160 * k;
    const sq = bag.squash * bag.squash;
    const fire = fireLevel();
    const hx = (sx) => (sx - 100) * k;
    const hy = (sy) => GRIP_Y + (sy - 50) * k;
    ctx.save();
    ctx.translate(bag.x + (G.freeze > 0 ? rand(-1.5, 1.5) : 0), pivotY - G.kick * 7);
    ctx.rotate(bag.tilt);
    ctx.translate(0, -pivotY);
    if (fire > 0) {
      const cy = d.top + d.h * 0.6;
      const g = ctx.createRadialGradient(0, cy, 4, 0, cy, d.w * 1.5);
      g.addColorStop(0, 'rgba(255,179,44,.8)');
      g.addColorStop(1, 'rgba(255,141,43,0)');
      ctx.fillStyle = g;
      ctx.fillRect(-d.w * 1.6, cy - d.w * 1.6, d.w * 3.2, d.w * 3.2);
    }
    const layer = (which) => {
      if (!ART.hand) return;
      const args = [-100 * k, GRIP_Y - 50 * k, 200 * k, 260 * k];
      ctx.drawImage(ART.hand[which], ...args);
      const over = fire > 0 ? ART.hot : G.freeze > 0 ? ART.icy : null;
      if (over) {
        ctx.save();
        ctx.globalAlpha = fire > 0 ? Math.min(1, fire) * (0.75 + 0.25 * Math.sin(G.clock * 14)) : 0.85;
        ctx.drawImage(over[which], ...args);
        ctx.restore();
      }
    };
    layer('back');
    if (fire > 0) ARM_FLAMES.forEach(([sx, sy, h, lean], i) => flame(hx(sx), hy(sy), h * k * fire, h * k * 0.55, lean, i * 1.7));
    ctx.save();
    ctx.translate(0, d.bottom);
    ctx.scale(1 + 0.07 * sq, 1 - 0.09 * sq);
    const shown = G.goalHit && !NO_GOAL ? PILE.length : Math.round(Math.min(1, G.score / GOAL) * PILE.length);
    for (let i = 0; i < shown; i++) {
      const s = PILE[i];
      drawSprite(ART.candies[s.img % ART.candies.length], s.dx * d.w, -d.h + s.dy * d.h, d.w * 0.42, s.rot);
    }
    if (bag.img) {
      if (HW) {
        // black Halloween pouches get their own neon glow so they read on the night sky
        ctx.shadowColor = CFG.bagGlow?.[bag.key] || '#34f466';
        ctx.shadowBlur = 16 + 6 * Math.sin(G.clock * 3);
        ctx.shadowOffsetY = 0;
      } else {
        ctx.shadowColor = 'rgba(20,11,18,.3)';
        ctx.shadowOffsetY = 6;
      }
      ctx.drawImage(bag.img, -d.w / 2, -d.h, d.w, d.h);
      ctx.shadowColor = 'transparent';
      ctx.shadowBlur = 0;
    }
    if (G.freeze > 0 && HW) {
      // webbed: strands across the bag
      const cx = 0, cy = -d.h * 0.55;
      ctx.strokeStyle = 'rgba(245,242,255,.92)';
      ctx.lineWidth = 1.8;
      for (let i = 0; i < 10; i++) {
        const a = (i / 10) * Math.PI * 2 + 0.3;
        ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(cx + Math.cos(a) * d.w * 0.62, cy + Math.sin(a) * d.h * 0.62); ctx.stroke();
      }
      [0.16, 0.3, 0.46].forEach((f) => {
        ctx.beginPath();
        for (let i = 0; i <= 10; i++) {
          const a = (i / 10) * Math.PI * 2 + 0.3;
          const px = cx + Math.cos(a) * d.w * f * 1.2, py = cy + Math.sin(a) * d.h * f;
          if (!i) ctx.moveTo(px, py); else ctx.lineTo(px, py);
        }
        ctx.stroke();
      });
    } else if (G.freeze > 0) {
      ctx.fillStyle = 'rgba(175,228,255,.55)';
      ctx.strokeStyle = 'rgba(255,255,255,.9)';
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.roundRect ? ctx.roundRect(-d.w / 2 - 3, -d.h - 3, d.w + 6, d.h + 6, 10) : ctx.rect(-d.w / 2 - 3, -d.h - 3, d.w + 6, d.h + 6);
      ctx.fill();
      ctx.stroke();
    }
    ctx.restore();
    layer('front');
    if (fire > 0) FINGER_FLAMES.forEach(([sx, sy, h], i) => flame(hx(sx), hy(sy), h * k * fire, h * k * 0.58, (sx - 100) / 220, i * 2.3 + 0.7));
    if (G.freeze > 0) {
      // frost sparkles on the frozen hand
      ctx.fillStyle = '#ffffff';
      for (let i = 0; i < 7; i++) {
        const px = hx(50 + ((i * 37) % 100));
        const py = hy(60 + ((i * 53) % 110));
        const r = 2.5 + 1.5 * Math.sin(G.clock * 9 + i);
        ctx.beginPath();
        ctx.moveTo(px, py - r * 2); ctx.lineTo(px + r * 0.6, py); ctx.lineTo(px, py + r * 2); ctx.lineTo(px - r * 0.6, py);
        ctx.closePath();
        ctx.fill();
      }
    }
    ctx.restore();
    // heat timer: a little burning fuse above the bag
    if (G.heat > 0) {
      const bw = Math.max(54, d.w * 0.9);
      const x0 = bag.x - bw / 2;
      const y0 = d.top - 22;
      ctx.save();
      ctx.fillStyle = 'rgba(20,11,18,.55)';
      ctx.beginPath();
      ctx.roundRect ? ctx.roundRect(x0, y0, bw, 9, 5) : ctx.rect(x0, y0, bw, 9);
      ctx.fill();
      const f = clamp(G.heat / HEAT_SECONDS, 0, 1);
      const g = ctx.createLinearGradient(x0, 0, x0 + bw, 0);
      g.addColorStop(0, '#df1f3d');
      g.addColorStop(1, '#ffb32c');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.roundRect ? ctx.roundRect(x0 + 1.5, y0 + 1.5, (bw - 3) * f, 6, 3) : ctx.rect(x0 + 1.5, y0 + 1.5, (bw - 3) * f, 6);
      ctx.fill();
      ctx.restore();
    }
  };
  const drawTexts = () => {
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.lineJoin = 'round';
    for (const t of G.texts) {
      const u = t.t / t.life;
      const pop = t.t < 0.12 ? lerp(0.4, 1.18, t.t / 0.12) : t.t < 0.22 ? lerp(1.18, 1, (t.t - 0.12) / 0.1) : 1;
      const alpha = u > 0.7 ? 1 - (u - 0.7) / 0.3 : 1;
      const y = t.big ? t.y : t.y - u * 60;
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.translate(t.x, y);
      ctx.rotate(t.tilt);
      ctx.scale(pop, pop);
      ctx.font = `900 ${t.size}px Inter, "Arial Black", sans-serif`;
      const maxW = W - 24;
      const tw = ctx.measureText(t.text).width;
      if (tw > maxW) ctx.scale(maxW / tw, maxW / tw);
      ctx.lineWidth = Math.max(5, t.size * 0.22);
      ctx.strokeStyle = INK;
      if (t.big) {
        ctx.fillStyle = INK;
        ctx.fillText(t.text, 0, t.size * 0.12);
      }
      ctx.strokeText(t.text, 0, 0);
      ctx.fillStyle = t.color;
      ctx.fillText(t.text, 0, 0);
      ctx.restore();
    }
  };
  const draw = () => {
    ctx.clearRect(0, 0, W, H);
    ctx.save();
    if (G.shake > 0 && !reduceMotion) ctx.translate(rand(-1, 1) * 11 * G.shake, rand(-1, 1) * 8 * G.shake);
    drawPlayer();
    for (const it of G.items) {
      const size = it.r * 2.35;
      if (it.type === 'bonus') {
        ctx.save();
        ctx.globalAlpha = 0.45 + 0.3 * Math.sin(it.wob * 2);
        ctx.fillStyle = '#ff3b3b';
        ctx.beginPath();
        ctx.arc(it.x, it.y, it.r * (1.4 + 0.12 * Math.sin(it.wob * 2)), 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
        drawSprite(it.img, it.x, it.y, size * 1.02 * (it.scale ?? 1), 0);
      } else if (it.type === 'pepper' || it.type === 'pouch') {
        ctx.save();
        ctx.globalAlpha = 0.55 + 0.25 * Math.sin(it.wob * 2);
        ctx.fillStyle = it.type === 'pepper' ? '#ffb32c' : '#d6fb51';
        ctx.beginPath();
        ctx.arc(it.x, it.y, it.r * 1.35, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
        drawSprite(it.img, it.x, it.y, it.type === 'pepper' ? size * 1.05 : size * 0.95, Math.sin(it.wob) * 0.35);
      } else {
        drawSprite(it.img, it.x, it.y, size * (it.scale ?? 1), it.rot);
      }
    }
    for (const p of G.parts) {
      const life = 1 - p.t / p.life;
      ctx.save();
      if (p.kind === 'smoke') {
        ctx.globalAlpha = 0.45 * life;
        ctx.fillStyle = p.c;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.s * (1 + (1 - life) * 1.6), 0, Math.PI * 2);
        ctx.fill();
      } else if (p.kind === 'ember') {
        ctx.globalCompositeOperation = 'lighter';
        ctx.globalAlpha = life;
        ctx.fillStyle = p.c;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.s * (0.5 + life * 0.5), 0, Math.PI * 2);
        ctx.fill();
      } else if (p.kind === 'streak') {
        ctx.globalAlpha = 0.55 * life;
        ctx.strokeStyle = p.c;
        ctx.lineWidth = 2.5;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(p.x, p.y);
        ctx.lineTo(p.x, p.y - p.s);
        ctx.stroke();
      } else {
        ctx.globalAlpha = life;
        ctx.fillStyle = p.c;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot || 0);
        ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.8);
      }
      ctx.restore();
    }
    drawTexts();
    ctx.restore();
  };

  /* Loop */
  let raf = 0, last = 0, stopAt = 0;
  const frame = (now) => {
    const dt = Math.min(0.033, (now - (last || now)) / 1000);
    last = now;
    if (G.state !== 'paused') G.clock += dt;
    if (G.state === 'playing') step(dt, 'play');
    else if (G.state === 'counting' || G.state === 'milestone') step(dt, 'fx');
    else if (G.state === 'over') step(dt, 'over');
    if (G.state !== 'paused' && !reduceMotion) {
      G.raysA = (G.raysA + dt * 4 * (G.state === 'playing' ? speedAt(G.t) : 1)) % 360;
      if (raysEl) raysEl.style.transform = `rotate(${G.raysA.toFixed(2)}deg)`;
    }
    draw();
    if (stopAt && now > stopAt) { raf = 0; stopAt = 0; return; }
    raf = requestAnimationFrame(frame);
  };
  const startLoop = () => {
    stopAt = 0;
    last = 0;
    stage.classList.add('is-driven');
    if (!raf) raf = requestAnimationFrame(frame);
  };
  const stopLoopSoon = () => { stopAt = performance.now() + 1500; };

  /* Confetti over everything */
  const confetti = () => {
    if (reduceMotion) return;
    const c = document.createElement('canvas');
    c.className = 'ccg-burst-fx';
    document.body.appendChild(c);
    const dd = Math.min(2, window.devicePixelRatio || 1);
    c.width = innerWidth * dd;
    c.height = innerHeight * dd;
    const x = c.getContext('2d');
    x.scale(dd, dd);
    const cols = ['#F52E7A', '#FFB32C', '#D6FB51', '#FF4F98', '#83DFFF', '#140b12', '#55C95A'];
    const parts = Array.from({ length: 160 }, () => ({
      x: innerWidth / 2 + rand(-60, 60), y: innerHeight * 0.55, vx: rand(-9, 9), vy: rand(-19, -6), g: rand(0.36, 0.5),
      w: rand(6, 13), h: rand(9, 18), a: rand(0, 6), va: rand(-0.25, 0.25), c: pick(cols),
    }));
    let f = 0;
    const tick = () => {
      x.clearRect(0, 0, innerWidth, innerHeight);
      for (const p of parts) {
        p.vy += p.g; p.vx *= 0.99; p.x += p.vx; p.y += p.vy; p.a += p.va;
        x.save(); x.translate(p.x, p.y); x.rotate(p.a); x.fillStyle = p.c; x.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); x.restore();
      }
      if (++f < 190) requestAnimationFrame(tick); else c.remove();
    };
    requestAnimationFrame(tick);
  };

  /* Run flow */
  let countToken = 0;
  const countdown = (steps) => new Promise((done) => {
    const token = ++countToken;
    let i = 0;
    const next = () => {
      if (token !== countToken || G.state !== 'counting') { if (token === countToken) countdownEl.innerHTML = ''; return; }
      if (i === steps.length) { countdownEl.innerHTML = ''; countdownEl.classList.remove('is-go'); done(); return; }
      countdownEl.classList.toggle('is-go', i === steps.length - 1);
      countdownEl.innerHTML = `<span>${steps[i]}</span>`;
      Sound.tick(i === steps.length - 1);
      i += 1;
      setTimeout(next, i === steps.length ? 480 : 600);
    };
    next();
  });
  const goLive = (steps) => {
    G.state = 'counting';
    stage.classList.remove('is-playing');
    stage.classList.add('is-counting');
    startLoop();
    countdown(steps).then(() => {
      if (G.state !== 'counting') return;
      G.state = 'playing';
      last = 0;
      stage.classList.replace('is-counting', 'is-playing');
    });
  };

  const start = (key) => {
    Sound.init();
    if (key && CFG.bags[key]) bag.key = key;
    bag.img = ART.bags[bag.key] || null;
    $$('[data-ccg-bag]').forEach((b) => b.classList.toggle('is-last', b.dataset.ccgBag === bag.key));
    G.attempt += 1;
    saved.plays += 1;
    persist();
    Object.assign(G, {
      t: 0, score: 0, lives: LIVES, streak: 0, items: [], parts: [], texts: [], heat: 0, freeze: 0, shake: 0, tier: 0,
      goalHit: NO_GOAL, goalAt: null, newBest: false, bestBefore: saved.bestScore || 0, fireBurst: 0, kick: 0, posted: false, rank: null, passedLead: false,
      assist: Math.min(ASSIST.length - 1, saved.losses || 0), lastChewX: null, lastChewT: -9,
      next: { chew: 0.2, bland: 0.4, celery: 0.5, ice: 0.5, pepper: rand(8, 11), pouch: 6, bonus: rand(8, 12) }, // counted from each type's START
    });
    bag.scale = ASSIST[G.assist].scale;
    bag.size = bag.shown = 1;
    resize();
    bag.x = bag.tx = W / 2;
    shownHud = '';
    stage.classList.remove('is-heat', 'is-frozen', 'is-hit');
    show(null);
    updateHud();
    newTicket();
    track('ccg_start', { attempt: G.attempt, bag: bag.key, assist: G.assist });
    goLive(['3', '2', '1', 'Chew!']);
  };

  const reachGoal = () => {
    G.goalHit = true;
    G.goalAt = +G.t.toFixed(1);
    saved.losses = 0;
    persist();
    track('ccg_goal', { attempt: G.attempt, seconds: G.goalAt, assist: G.assist });
    callout(`${GOAL}! Free 2-pack!`, '#d6fb51', 50);
    Sound.win();
    vibrate([40, 60, 40]);
    confetti();
    updateHud();
    if (saved.claimed) return; // already claimed: no interruption, straight on to the high score
    // first time: pause the run, reveal the mystery bag, then "Keep playing"
    G.state = 'milestone';
    stopLoopSoon();
    setTimeout(() => {
      stage.classList.remove('is-playing', 'is-heat', 'is-frozen');
      saved.claimed = { at: Date.now() };
      persist();
      // sent once the cart answers, so the email names the flavor that actually landed in the cart
      claimReward('run').then((res) => {
        const gift = res?.gift;
        kEvent('Chili Drop Won', { goal_seconds: G.goalAt, gift: gift?.name || null, gift_variant_id: gift?.id || null, gift_status: res?.status || 'offline', min_order: CFG.minOrder, discount_code: CODE || null });
        track('ccg_claim', { seconds: G.goalAt, gift: gift?.name });
      });
    }, 900);
  };

  const resumeRun = () => {
    if (G.state !== 'milestone') return; // only a run paused at the goal can carry on
    show(null);
    goLive(['3', '2', '1', 'Go!']);
  };

  const endRound = (screen, delay) => {
    stopLoopSoon();
    setTimeout(() => {
      stage.classList.remove('is-playing', 'is-heat', 'is-frozen', 'is-counting');
      show(screen);
    }, delay);
  };

  const gameOver = () => {
    if (G.state !== 'playing') return;
    G.state = 'over';
    const score = G.score;
    const top = speedAt(G.t).toFixed(1);
    if (!G.goalHit) {
      saved.losses = (saved.losses || 0) + 1;
      persist();
      const short = GOAL - score;
      let title = HW ? 'Ghosted. You’re out.' : 'Too bland. You’re out.';
      if (short <= 2) title = 'SO. CLOSE.';
      else if (short <= 5) title = 'So close it hurts.';
      $('[data-ccg-lose-title]').textContent = title;
      $('[data-ccg-lose-kicker]').textContent = `Run ${G.attempt}`;
      $('[data-ccg-lose-sub]').innerHTML = `${HW ? 'Three ghosts got you.' : 'Three bland gummies got you.'} You caught <b>${score}</b> of ${GOAL}.${short <= 5 ? ` Just ${short} more for the free 2-pack.` : ''}`;
      const next = ASSIST[Math.min(ASSIST.length - 1, saved.losses)];
      const up = $('[data-ccg-upgrade]');
      up.hidden = !next.label || saved.losses > ASSIST.length - 1;
      up.textContent = next.label;
      Sound.lose();
      track('ccg_lose', { attempt: G.attempt, score, assist: G.assist });
      endRound('lose', 950);
      return;
    }
    const prev = saved.bestScore || 0;
    const isBest = score > prev;
    if (isBest) saved.bestScore = score;
    persist();
    syncBestChip();
    $('[data-ccg-over-score]').textContent = score;
    $('[data-ccg-over-kicker]').textContent = isBest && prev ? 'New high score!' : 'Game over';
    $('[data-ccg-over-sub]').innerHTML = isBest && prev
      ? `Old best was ${prev}. Top speed <b>x${top}</b>.`
      : `Your best: <b>${saved.bestScore}</b>. Top speed <b>x${top}</b>.`;
    $('[data-ccg-newbest]').hidden = !(isBest && prev);
    const overShop = $('[data-ccg-over-shop]');
    if (overShop) overShop.hidden = !saved.claimed;
    if (isBest && prev) { Sound.win(); confetti(); } else Sound.lose();
    G.scoreSent = false;
    setupPost();
    if (!LB) sendScore({ new_best: isBest });
    track('ccg_over', { attempt: G.attempt, score, best: saved.bestScore, new_best: isBest, seconds: +G.t.toFixed(1), top_speed: +top });
    endRound('over', 1000);
  };

  const pause = () => {
    if (G.state !== 'playing' && G.state !== 'counting') return;
    G.state = 'paused';
    countToken += 1;
    countdownEl.innerHTML = '';
    pausedEl.hidden = false;
  };
  const resume = () => {
    if (G.state !== 'paused') return;
    pausedEl.hidden = true;
    goLive(['3', '2', '1', 'Go!']);
  };

  /* Klaviyo: subscribe once when a player signs in, then events that drive the emails
     (Chili Drop Joined, Chili Drop Won, Chili Drop Score). Nothing is sent without a list ID. */
  const kpost = (path, data) => fetch(`https://a.klaviyo.com/client/${path}?company_id=${encodeURIComponent(CFG.klaviyoCompany)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
    body: JSON.stringify({ data }),
    keepalive: true,
  }).then((r) => r.ok);
  const kOn = () => !!(CFG.klaviyoCompany && CFG.klaviyoList && saved.profile?.email);
  let kWarned = false;
  const kSkip = () => {
    if (!kWarned) console.warn('[Chili Drop] No Klaviyo list set, so nothing was sent to Klaviyo (test mode).');
    kWarned = true;
  };
  const kProfile = () => ({
    data: { type: 'profile', attributes: { email: saved.profile.email, properties: { chili_drop_name: saved.profile.name, chili_drop_best: saved.bestScore || null } } },
  });
  function kEvent(metric, props = {}) {
    if (!kOn()) return kSkip();
    kpost('events', {
      type: 'event',
      attributes: {
        properties: { ...props, player_name: saved.profile.name, ...(CFG.edition ? { edition: CFG.edition } : {}) },
        metric: { data: { type: 'metric', attributes: { name: metric } } },
        profile: kProfile(),
      },
    }).catch(() => {});
  }
  const kJoin = (bagKey) => {
    if (!kOn()) return kSkip();
    kpost('subscriptions', {
      type: 'subscription',
      attributes: {
        custom_source: 'Chili Drop game',
        // the client endpoint takes no 'subscriptions' block: posting to the list is the consent
        profile: { data: { type: 'profile', attributes: { email: saved.profile.email, properties: { chili_drop_name: saved.profile.name } } } },
      },
      relationships: { list: { data: { type: 'list', id: CFG.klaviyoList } } },
    }).catch(() => {});
    kEvent('Chili Drop Joined', { bag: bagKey });
  };
  // one score event per finished run, with the rank when the leaderboard is on
  const sendScore = (extra = {}) => {
    if (G.scoreSent) return;
    G.scoreSent = true;
    kEvent('Chili Drop Score', { score: G.score, best: saved.bestScore, top_speed: +speedAt(G.t).toFixed(1), seconds: +G.t.toFixed(1), ...extra });
  };
  // Only used when a discount code is configured: drops it in the cart cookie right away
  const applyCode = () => { if (CODE) fetch(`/discount/${encodeURIComponent(CODE)}?redirect=%2Fcart.js`, { credentials: 'same-origin' }).catch(() => {}); };

  /* The mystery bag: one per player, picked once (weighted by stock so both flavors clear), then kept */
  const GIFTS = (CFG.gifts || []).filter((g) => g && g.id);
  const giftById = (id) => GIFTS.find((g) => String(g.id) === String(id));
  const pickGift = () => {
    const prior = giftById(saved.gift);
    if (prior && prior.available) return prior;
    const pool = GIFTS.filter((g) => g.available);
    if (!pool.length) return prior || null;
    const weights = pool.map((g) => Math.max(1, Number(g.stock) || 1));
    let r = Math.random() * weights.reduce((a, b) => a + b, 0);
    const chosen = pool.find((g, i) => (r -= weights[i]) < 0) || pool[0];
    saved.gift = chosen.id;
    persist();
    return chosen;
  };
  const cartReq = (url, body) => fetch(url, {
    method: body ? 'POST' : 'GET',
    credentials: 'same-origin',
    headers: body ? { Accept: 'application/json', 'Content-Type': 'application/json' } : { Accept: 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  });
  // Makes sure exactly one mystery bag sits in the cart. status: present | added | soldout | offline
  const ensureGift = async () => {
    let cart;
    try {
      const r = await cartReq('/cart.js');
      if (!r.ok) throw new Error(String(r.status));
      cart = await r.json();
    } catch (_) {
      return { status: 'offline', gift: pickGift() };
    }
    const line = (cart.items || []).find((i) => giftById(i.variant_id));
    if (line) {
      saved.gift = line.variant_id;
      persist();
      return { status: 'present', gift: giftById(line.variant_id) };
    }
    const first = pickGift();
    const order = [first, ...GIFTS.filter((g) => g !== first && g.available)].filter(Boolean);
    for (const g of order) {
      try {
        const r = await cartReq('/cart/add.js', { items: [{ id: g.id, quantity: 1, properties: { _chili_drop: 'mystery bag' } }] });
        if (r.ok) {
          saved.gift = g.id;
          persist();
          return { status: 'added', gift: g };
        }
      } catch (_) {}
    }
    return { status: 'soldout', gift: null };
  };

  const claimReward = async (from) => {
    const card = $('.ccg-card--code');
    const mystery = $('[data-ccg-mystery]');
    const img = $('[data-ccg-gift-img]');
    const name = $('[data-ccg-gift-name]');
    const kicker = $('[data-ccg-reveal-kicker]');
    const note = $('[data-ccg-gift-note]');
    const midRun = from === 'run';
    $('[data-ccg-continue]').hidden = !midRun;
    $$('[data-ccg-again]', screens.code).forEach((b) => { b.hidden = midRun; });
    card.classList.remove('is-revealed');
    mystery.classList.remove('is-revealed', 'is-soldout');
    kicker.textContent = 'Your mystery 2-pack is...';
    name.innerHTML = '&nbsp;';
    const guess = pickGift();
    if (guess) img.src = guess.art;
    show('code');
    for (let i = 0; i < 6; i++) Sound.tone(500 + i * 60, 0.05, { type: 'square', vol: 0.04, delay: i * 0.24 });
    const [res] = await Promise.all([ensureGift(), wait(1700)]);
    if (CODE) {
      applyCode();
      $$('[data-ccg-code-text]', document).forEach((el) => { el.textContent = CODE; });
      $('[data-ccg-code-note]').hidden = false;
    }
    if (!res.gift || res.status === 'soldout') {
      mystery.classList.add('is-soldout');
      kicker.textContent = 'Plot twist';
      name.textContent = 'All gone!';
      note.textContent = 'Mystery 2-packs just sold out. Sorry! You keep the bragging rights.';
      card.classList.add('is-revealed');
      track('ccg_gift', { status: 'soldout' });
      return res;
    }
    if (img.getAttribute('src') !== res.gift.art) img.src = res.gift.art;
    kicker.textContent = 'Your mystery 2-pack is';
    name.textContent = `${res.gift.name}!`;
    note.innerHTML = res.status === 'offline'
      ? `<b>Free with any $${CFG.minOrder}+ order.</b>`
      : `It's in your cart. <b>Free with any $${CFG.minOrder}+ order.</b>`;
    mystery.classList.add('is-revealed');
    card.classList.add('is-revealed');
    $$('[data-ccg-gift-label]', document).forEach((el) => { el.textContent = res.gift.name; });
    $('[data-ccg-returning]').hidden = false;
    Sound.win();
    vibrate([30, 40, 30]);
    confetti();
    track('ccg_gift', { status: res.status, gift: res.gift.name });
    const focusBtn = midRun ? $('[data-ccg-continue]') : $('[data-ccg-shop]', screens.code);
    focusBtn?.classList.add('is-pulsing');
    setTimeout(() => focusBtn?.focus({ preventScroll: true }), 400);
    return res;
  };

  /* Leaderboard: everyone's best score with a name, served by the chili-drop-api Vercel app.
     Each run gets a signed ticket at the start; the server only takes a score with a fresh ticket
     and a play time that fits. Hidden entirely when no leaderboard URL is set. */
  const LB = String(CFG.leaderboardUrl || '').replace(/\/+$/, '');
  const newPlayerId = () => (window.crypto?.randomUUID ? crypto.randomUUID() : `p${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`);
  if (!saved.player) {
    saved.player = newPlayerId();
    persist();
  }
  const lbFetch = async (path, payload) => {
    let url = `${LB}${path}`;
    if (BOARD) {
      if (payload) payload = { ...payload, board: BOARD };
      else url += `${url.includes('?') ? '&' : '?'}board=${encodeURIComponent(BOARD)}`;
    }
    const r = await fetch(url, payload ? { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(payload) } : {});
    const j = await r.json().catch(() => ({}));
    return { ...j, ok: r.ok && j.ok !== false, status: r.status };
  };
  function newTicket() {
    G.ticket = null;
    if (!LB) return;
    lbFetch('/api/start', {}).then((j) => { if (j.ok && j.run) G.ticket = { run: j.run, ts: j.ts, sig: j.sig }; }).catch(() => {});
  }
  const renderBoard = (list, rows) => {
    list.textContent = '';
    rows.forEach((row) => {
      const li = document.createElement('li');
      if (row.gap) {
        li.className = 'is-gap';
        li.textContent = '⋯';
      } else {
        if (row.me) li.className = 'is-me';
        const b = document.createElement('b');
        b.textContent = row.rank;
        const name = document.createElement('span');
        name.textContent = row.name;
        const score = document.createElement('i');
        score.textContent = row.score;
        li.append(b, name, score);
      }
      list.appendChild(li);
    });
  };
  // the top n, plus your own row underneath when you're further down
  const withMe = (top, rank, best, n) => {
    const rows = (top || []).slice(0, n);
    if (rank && rank > n) rows.push({ gap: true }, { rank, name: saved.profile?.name || 'You', score: best, me: true });
    return rows;
  };
  // Weekly board (Halloween edition): time left until Monday 12:00 AM PT, when #1 wins the prize
  const timeLeft = (ends) => {
    const ms = Number(ends) - Date.now();
    if (!(ms > 0)) return 'closing now';
    const m = Math.floor(ms / 60000), h = Math.floor(m / 60), d = Math.floor(h / 24);
    return d ? `${d}d ${h % 24}h left` : h ? `${h}h ${m % 60}m left` : `${Math.max(1, m)}m left`;
  };
  const prizeLine = (j) => {
    if (!BOARD || !PRIZE) return '';
    const left = j.week?.ends ? ` (${timeLeft(j.week.ends)})` : '';
    if (j.rank === 1) return `You're #1 this week. Hold it until Sunday 11:59 PM PT${left} and the ${PRIZE} is yours.`;
    const lead = j.top?.[0]?.score;
    return `#1 when the week ends Sunday 11:59 PM PT${left} wins the ${PRIZE}.${lead ? ` Score to beat: ${lead}.` : ''}`;
  };
  const post = {
    el: $('[data-ccg-post]'),
    form: $('[data-ccg-name-form]'),
    input: $('#ccg-name'),
    err: $('[data-ccg-name-error]'),
    btn: $('[data-ccg-name-submit]'),
    result: $('[data-ccg-post-result]'),
    rank: $('[data-ccg-post-rank]'),
    list: $('[data-ccg-post-list]'),
    prize: $('[data-ccg-post-prize]'),
  };
  const NOT_VERIFIED = 'This run could not be verified, so it stays off the board. The next one counts.';
  const NAME_ERRORS = {
    name: 'Keep it clean and short (14 characters max).',
    ticket: NOT_VERIFIED,
    time: NOT_VERIFIED,
    score: NOT_VERIFIED,
    used: 'This run is already on the board.',
    'slow down': 'Easy, champ. Try again in a minute.',
  };
  const showPosted = (j) => {
    G.posted = true;
    G.rank = j.rank;
    post.form.hidden = true;
    post.result.hidden = false;
    post.rank.innerHTML = j.rank ? `You're <em>#${j.rank}</em> of ${j.total} chewer${j.total === 1 ? '' : 's'}${BOARD ? ' this week' : ''}` : 'Posted!';
    renderBoard(post.list, withMe(j.top, j.rank, j.best, 5));
    if (BOARD) leaderScore = j.top?.[0]?.score || leaderScore;
    if (post.prize) { post.prize.textContent = prizeLine(j); post.prize.hidden = !post.prize.textContent; }
    if (j.rank === 1) confetti();
    sendScore({ rank: j.rank, total: j.total, board_best: j.top?.[0]?.score ?? j.best, ...(j.week ? { week: j.week.id } : {}) });
    track('ccg_board_post', { rank: j.rank, total: j.total, score: G.score });
  };
  const submitName = async (name) => {
    post.err.hidden = true;
    post.btn.disabled = true;
    let j;
    try {
      if (G.posted) j = await lbFetch('/api/name', { player: saved.player, name });
      else if (!G.ticket) j = { ok: false, error: 'ticket' };
      else j = await lbFetch('/api/score', { ...G.ticket, player: saved.player, name, score: G.score, ms: Math.round(G.t * 1000), ...(BOARD ? { email: saved.profile?.email } : {}) });
    } catch (_) {
      j = { ok: false };
    }
    post.btn.disabled = false;
    if (j.ok) {
      if (saved.profile) saved.profile.name = name;
      persist();
      showPosted(j);
      loadTopLine();
      return;
    }
    post.form.hidden = false;
    post.result.hidden = true;
    post.err.textContent = NAME_ERRORS[j.error] || 'The leaderboard is having a moment. Try again.';
    post.err.hidden = false;
  };
  function setupPost() {
    if (!LB || !G.goalHit || G.score < 1) { post.el.hidden = true; return; }
    post.el.hidden = false;
    post.err.hidden = true;
    post.result.hidden = true;
    post.form.hidden = false;
    post.input.value = saved.profile?.name || '';
    if (saved.profile?.name) {
      // signed-in players go straight on the board; they can still change the name
      post.form.hidden = true;
      submitName(saved.profile.name);
    }
  }
  post.form.addEventListener('submit', (e) => {
    e.preventDefault();
    const v = post.input.value.trim();
    if (!v) { post.input.focus(); return; }
    submitName(v);
  });
  $('[data-ccg-name-change]').addEventListener('click', () => {
    post.result.hidden = true;
    post.form.hidden = false;
    post.input.value = saved.profile?.name || '';
    post.input.focus();
  });

  let boardFrom = 'intro';
  const openBoard = async (from) => {
    boardFrom = from;
    show('board');
    const list = $('[data-ccg-board-list]', screens.board);
    const sub = $('[data-ccg-board-sub]');
    const meEl = $('[data-ccg-board-me]');
    list.textContent = '';
    sub.textContent = 'Loading the legends...';
    meEl.hidden = true;
    track('ccg_board_view', { from });
    try {
      const j = await lbFetch(`/api/board?n=10&player=${encodeURIComponent(saved.player)}`);
      if (!j.ok) throw new Error('board');
      if (BOARD) {
        const left = j.week?.ends ? ` ${timeLeft(j.week.ends)}.` : '';
        sub.textContent = j.total
          ? `${j.total} chewer${j.total === 1 ? '' : 's'} this week. #1 at Sunday 11:59 PM PT wins a ${PRIZE}.${left}`
          : `Nobody on this week's board yet. ${NO_GOAL ? 'Play a run' : `Catch ${GOAL}`} and claim #1.${left}`;
      } else {
        sub.textContent = j.total ? `${j.total} chewer${j.total === 1 ? '' : 's'} and counting. Catch ${GOAL} to get on it.` : `Nobody yet. Catch ${GOAL} and be the first legend.`;
      }
      renderBoard(list, withMe(j.top, j.me?.rank, j.me?.best, 10));
      if (BOARD) leaderScore = j.top?.[0]?.score || 0;
      if (j.me) {
        meEl.hidden = false;
        meEl.textContent = `You: #${j.me.rank} with ${j.me.best}.`;
      }
    } catch (_) {
      sub.textContent = 'The leaderboard is having a moment. Try again soon.';
    }
  };
  $$('[data-ccg-board-open]').forEach((b) => b.addEventListener('click', () => openBoard(b.closest('[data-ccg-screen]')?.dataset.ccgScreen || 'intro')));
  $('[data-ccg-board-back]').addEventListener('click', () => show(boardFrom));

  async function loadTopLine() {
    if (!LB) return;
    const el = $('[data-ccg-topline]');
    const txt = $('[data-ccg-topline-text]');
    try {
      const j = await lbFetch('/api/board?n=1');
      if (!j.ok) return;
      const top = j.top?.[0];
      if (BOARD) leaderScore = top?.score || 0;
      txt.textContent = '';
      if (top) {
        const who = document.createElement('strong');
        who.textContent = top.name;
        txt.append(who, ` leads ${BOARD ? 'this week ' : ''}with ${top.score}`);
      } else {
        txt.textContent = BOARD ? 'Nobody on this week’s board yet. Be #1.' : 'No high scores yet. Be the first legend.';
      }
      const clock = $('[data-ccg-topline-clock]');
      if (clock && j.week?.ends) clock.textContent = timeLeft(j.week.ends);
      el.hidden = false;
    } catch (_) {}
  }

  /* Sign in once: name for the leaderboard, email for the prize. Replays never ask again. */
  const join = {
    form: $('[data-ccg-join-form]'),
    name: $('#ccg-join-name'),
    email: $('#ccg-join-email'),
    err: $('[data-ccg-join-error]'),
    btn: $('[data-ccg-join-submit]'),
  };
  let pendingBag = null;
  const NAME_OK = /^[\p{L}\p{N} ._'!?&-]{1,14}$/u;
  const joinError = (msg, field) => {
    join.err.textContent = msg;
    join.err.hidden = false;
    if (!field) return;
    field.classList.remove('is-bad');
    void field.offsetWidth;
    field.classList.add('is-bad');
    field.focus();
  };
  const askToJoin = (key) => {
    pendingBag = key;
    join.err.hidden = true;
    join.name.value = saved.profile?.name || '';
    show('join');
    setTimeout(() => join.name.focus({ preventScroll: true }), 350);
    track('ccg_join_view', { bag: key });
  };
  function syncWhoami() {
    const el = $('[data-ccg-whoami]');
    el.hidden = !saved.profile;
    if (saved.profile) $('[data-ccg-whoami-name]').textContent = saved.profile.name;
  }
  join.form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const name = join.name.value.normalize('NFKC').replace(/\s+/g, ' ').trim();
    const email = join.email.value.trim();
    if (!NAME_OK.test(name)) return joinError('Pick a name with letters or numbers, 14 characters max.', join.name);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return joinError('That email looks off. Try again?', join.email);
    join.err.hidden = true;
    if (LB) {
      // ask the leaderboard if the name is clean before it goes public
      join.btn.disabled = true;
      const check = await Promise.race([lbFetch('/api/check', { name }).catch(() => ({ ok: true })), wait(3000).then(() => ({ ok: true }))]);
      join.btn.disabled = false;
      if (!check.ok && check.error === 'name') return joinError('Keep it clean. Pick another name.', join.name);
    }
    saved.profile = { name, email, at: Date.now() };
    persist();
    kJoin(pendingBag);
    track('ccg_lead', { bag: pendingBag });
    try { window.fbq?.('track', 'Lead', { content_name: 'Chili Drop' }); } catch (_) {}
    try { window.gtag?.('event', 'generate_lead', { method: 'chili_drop' }); } catch (_) {}
    syncWhoami();
    Sound.init();
    artReady.then(() => start(pendingBag));
  });
  $('[data-ccg-join-back]').addEventListener('click', () => show('intro'));
  $('[data-ccg-switch]').addEventListener('click', () => {
    // someone else on this device: fresh player, fresh best score, fresh prize
    const muted = saved.muted;
    Object.keys(saved).forEach((k) => delete saved[k]);
    Object.assign(saved, { losses: 0, plays: 0, bestScore: 0, muted, player: newPlayerId() });
    persist();
    syncWhoami();
    syncBestChip();
    const returning = $('[data-ccg-returning]');
    if (returning) returning.hidden = true;
    askToJoin(bag.key);
  });

  /* Controls */
  let drag = null;
  const localX = (clientX) => clientX - stage.getBoundingClientRect().left;
  canvas.addEventListener('pointerdown', (e) => {
    if (G.state === 'paused') return resume();
    Sound.init();
    if (e.pointerType === 'mouse') { if (G.freeze <= 0) bag.tx = localX(e.clientX); return; }
    drag = { id: e.pointerId, x: e.clientX };
    canvas.setPointerCapture?.(e.pointerId);
  });
  canvas.addEventListener('pointermove', (e) => {
    const frozen = G.state === 'playing' && G.freeze > 0;
    if (e.pointerType === 'mouse') { if (G.state !== 'paused' && !frozen) bag.tx = localX(e.clientX); return; }
    if (!drag || drag.id !== e.pointerId) return;
    // relative drag so your thumb never hides the bag
    if (!frozen) bag.tx += (e.clientX - drag.x) * 1.2;
    drag.x = e.clientX;
    e.preventDefault();
  });
  const endDrag = (e) => { if (drag && drag.id === e.pointerId) drag = null; };
  canvas.addEventListener('pointerup', endDrag);
  canvas.addEventListener('pointercancel', endDrag);
  const keyName = (e) => ({ ArrowLeft: 'left', a: 'left', A: 'left', ArrowRight: 'right', d: 'right', D: 'right' }[e.key]);
  window.addEventListener('keydown', (e) => {
    const k = keyName(e);
    if (k && (G.state === 'playing' || G.state === 'counting')) { keys[k] = true; e.preventDefault(); }
    if ((e.key === 'p' || e.key === 'Escape') && G.state === 'playing') pause();
    else if (G.state === 'paused' && (e.key === ' ' || e.key === 'Enter' || e.key === 'p')) { e.preventDefault(); resume(); }
  });
  window.addEventListener('keyup', (e) => { const k = keyName(e); if (k) keys[k] = false; });
  document.addEventListener('visibilitychange', () => { if (document.hidden) pause(); });
  pausedEl.addEventListener('click', resume);

  $$('[data-ccg-bag]').forEach((b) => b.addEventListener('click', () => {
    Sound.init();
    if (!saved.profile?.email) return askToJoin(b.dataset.ccgBag);
    artReady.then(() => start(b.dataset.ccgBag));
  }));
  $('[data-ccg-retry]')?.addEventListener('click', () => start());
  $$('[data-ccg-again]').forEach((b) => b.addEventListener('click', () => start()));
  $('[data-ccg-change-bag]')?.addEventListener('click', () => show('intro'));
  $('[data-ccg-continue]')?.addEventListener('click', resumeRun);

  $$('[data-ccg-shop]', document).forEach((a) => {
    a.href = shopHref;
    a.addEventListener('click', async (e) => {
      track('ccg_shop_click', { gift: giftById(saved.gift)?.name });
      if (!saved.claimed) return;
      // put the bag back if they emptied their cart since winning, then go shop
      e.preventDefault();
      a.classList.add('is-busy');
      if (CODE) applyCode();
      await Promise.race([ensureGift(), wait(2500)]);
      location.href = shopHref;
    });
  });
  $('[data-ccg-copy]')?.addEventListener('click', async (e) => {
    if (!CODE) return;
    const btn = e.currentTarget;
    let ok = false;
    try { await navigator.clipboard.writeText(CODE); ok = true; } catch (_) {
      const ta = document.createElement('textarea');
      ta.value = CODE;
      document.body.appendChild(ta);
      ta.select();
      try { ok = document.execCommand('copy'); } catch (__) {}
      ta.remove();
    }
    if (ok) {
      btn.classList.add('is-copied');
      $('[data-ccg-copy-label]').textContent = 'Copied!';
      track('ccg_code_copy');
    }
  });
  $$('[data-ccg-share]').forEach((b) => b.addEventListener('click', async () => {
    const score = G.state === 'over' && G.goalHit ? G.score : saved.bestScore;
    const url = `${location.origin}${location.pathname}?utm_source=friend&utm_medium=share&utm_campaign=chili_drop`;
    const text = HW
      ? (score ? `I scored ${score} on the Halloween Chili Drop. Top score this week wins a ${PRIZE}. Beat that. 🎃` : `Catch the treats, dodge the ghosts. Top score this week wins a ${PRIZE}. 🎃`)
      : G.rank && G.state === 'over'
      ? `I'm #${G.rank} on the Chili Drop leaderboard with ${score}. Come get me. 🌶️`
      : score
      ? `I scored ${score} on the Chili Drop and won a free 2-pack of candy. Beat that. 🌶️`
      : `Catch ${GOAL} Chili Chews, win a free 2-pack of candy. 🌶️`;
    try {
      if (navigator.share) {
        await navigator.share({ title: 'Chili Drop', text, url });
        track('ccg_share', { method: 'native', score });
      } else {
        await navigator.clipboard.writeText(`${text} ${url}`);
        toast('Link copied. Go start a group chat war.');
        track('ccg_share', { method: 'copy', score });
      }
    } catch (_) {}
  }));
  // Weekly prize rules (Halloween edition)
  let rulesFrom = 'intro';
  $$('[data-ccg-rules-open]').forEach((b) => b.addEventListener('click', (e) => {
    e.preventDefault();
    rulesFrom = b.closest('[data-ccg-screen]')?.dataset.ccgScreen || 'intro';
    show('rules');
    track('ccg_rules_view', { from: rulesFrom });
  }));
  $('[data-ccg-rules-back]')?.addEventListener('click', () => show(rulesFrom));
  $$('[data-ccg-target]').forEach((a) => a.addEventListener('click', () => track('ccg_target_click', { from: a.closest('[data-ccg-screen]')?.dataset.ccgScreen })));
  const syncMute = () => {
    muteBtn.setAttribute('aria-pressed', String(Sound.muted));
    muteBtn.setAttribute('aria-label', Sound.muted ? 'Turn sound on' : 'Mute sound');
  };
  muteBtn.addEventListener('click', () => {
    Sound.muted = !Sound.muted;
    saved.muted = Sound.muted;
    persist();
    syncMute();
    Sound.init();
  });
  syncMute();

  /* Boot */
  // Trailer capture only (trailer/ builds a local page with "demo": true): lets a script steer the hand and stage moments
  if (CFG.demo) window.__ccgDemo = { G, bag, spawn, dims, show, callout, start, get W() { return W; }, get H() { return H; } };
  // show the default bag in the hand on the start screen too, not only once a run begins
  artReady.then(() => { if (!bag.img) { bag.img = ART.bags[bag.key] || null; if (!raf) draw(); } });
  const onResize = () => { resize(); if (!raf) draw(); };
  window.addEventListener('resize', onResize);
  window.visualViewport?.addEventListener('resize', onResize);
  resize();
  syncBestChip();
  if (saved.claimed && $('[data-ccg-returning]')) {
    const g = giftById(saved.gift);
    if (g) $$('[data-ccg-gift-label]', document).forEach((el) => { el.textContent = g.name; });
    $('[data-ccg-returning]').hidden = false;
  }
  syncWhoami();
  show('intro');
  loadTopLine();
  // Email links land on ?claim=<variant id>: put that free 2-pack in this browser's cart (never a second one), then go shop
  const claimId = new URLSearchParams(location.search).get('claim');
  if (claimId && giftById(claimId)) {
    saved.gift = giftById(claimId).id;
    saved.claimed = saved.claimed || { at: Date.now(), via: 'email' };
    persist();
    toast('Adding your free 2-pack...');
    Promise.race([ensureGift(), wait(3000)]).then((res) => {
      track('ccg_email_claim', { gift: res?.gift?.name, status: res?.status });
      location.replace(shopHref);
    });
  }
  track('ccg_view', { returning: !!saved.claimed, plays: saved.plays, best: saved.bestScore });
})();
